import briSk1 from "../assets/Skill/Thần lực ánh sáng.png";
import briSk2 from "../assets/Skill/Tốc độ quang minh.png";
import briSk3 from "../assets/Skill/Quang minh phán quyết.png";
import briSk4 from "../assets/Skill/Bất tử thánh thân.png";
import RichSk1 from "../assets/Skill/Thanh gươm biến ảo.png";
import RichSk2 from "../assets/Skill/Chặt và chém.png";
import RichSk3 from "../assets/Skill/Công thủ toàn diện.png";
import RichSk4 from "../assets/Skill/Vùng diệt quỷ.png";
import RyoSk1 from "../assets/Skill/Kiếm quyết.png";
import RyoSk2 from "../assets/Skill/Thần hành bất biến.png";
import RyoSk3 from "../assets/Skill/Nhất kích tất sát.png";
import RyoSk4 from "../assets/Skill/Loạn trảm.png";
import WuSk1 from "../assets/Skill/Vô địch thiên hạ.png";
import WuSk2 from "../assets/Skill/Phân thân thuật.png";
import WuSk3 from "../assets/Skill/Cân đẩu vân.png";
import WuSk4 from "../assets/Skill/Gậy như ý.png";
import QuiSk1 from "../assets/Skill/Đánh lén.png";
import QuiSk2 from "../assets/Skill/Chém đôi.png";
import QuiSk3 from "../assets/Skill/Đoản mệnh.png";
import QuiSk4 from "../assets/Skill/Ẩn sát.png";
import NakSk1 from "../assets/Skill/Thẩm phán oai nghiêm.png";
import NakSk2 from "../assets/Skill/Bồi thẩm đoàn.png";
import NakSk3 from "../assets/Skill/Nguồn cơn rắc rối.png";
import NakSk4 from "../assets/Skill/Gươm hành quyết.png";
import VerSk1 from "../assets/Skill/Huyết xích.png";
import VerSk2 from "../assets/Skill/Song xích.png";
import VerSk3 from "../assets/Skill/Xiềng xích.png";
import VerSk4 from "../assets/Skill/Đoạt mệnh xích.png";
import EnzSk1 from "../assets/Skill/Tín niệm.png";
import EnzSk2 from "../assets/Skill/Truy bức.png";
import EnzSk3 from "../assets/Skill/Câu hồn.png";
import EnzSk4 from "../assets/Skill/Hành quyết.png";
import KaiSk1 from "../assets/Skill/Truy nã.png";
import KaiSk2 from "../assets/Skill/Huyết luân.png";
import KaiSk3 from "../assets/Skill/Huyết kiếm.png";
import KaiSk4 from "../assets/Skill/Huyết kích.png";
import VeeSk1 from "../assets/Skill/Mê hoặc.png";
import VeeSk2 from "../assets/Skill/Dơi địa ngục.png";
import VeeSk3 from "../assets/Skill/Hôn gió.png";
import VeeSk4 from "../assets/Skill/Tiểu quỷ.png";
import MurSk1 from "../assets/Skill/Ảnh hồn.png";
import MurSk2 from "../assets/Skill/Tàn ảnh đao.png";
import MurSk3 from "../assets/Skill/Vô ảnh cực.png";
import MurSk4 from "../assets/Skill/Ảo ảnh trảm.png";
import LilSk1 from "../assets/Skill/Yêu hồ.png";
import LilSk2 from "../assets/Skill/Hồ quang lực.png";
import LilSk3 from "../assets/Skill/Hồ quang đạn.png";
import LilSk4 from "../assets/Skill/Biến ảnh hoán hình.png";
import HaySk1 from "../assets/Skill/Phản ứng dây chuyền.png";
import HaySk2 from "../assets/Skill/Chuỗi phi tiêu.png";
import HaySk3 from "../assets/Skill/Ảnh biến.png";
import HaySk4 from "../assets/Skill/Bão phi tiêu.png";
import OmeSk1 from "../assets/Skill/Sát khí.png";
import OmeSk2 from "../assets/Skill/Sát kiếm.png";
import OmeSk3 from "../assets/Skill/Sát niệm.png";
import OmeSk4 from "../assets/Skill/Sát vực.png";
import TulSk1 from "../assets/Skill/Lôi điện.png";
import TulSk2 from "../assets/Skill/Lôi quang.png";
import TulSk3 from "../assets/Skill/Lôi động.png";
import TulSk4 from "../assets/Skill/Lôi điểu.png";
import RazSk1 from "../assets/Skill/Đấm và lách.png";
import RazSk2 from "../assets/Skill/Cú đấm thăng hoa.png";
import RazSk3 from "../assets/Skill/Cú đấm chân không.png";
import RazSk4 from "../assets/Skill/Tả xung hữu đột.png";
import TrieuSk1 from "../assets/Skill/Long tướng.png";
import TrieuSk2 from "../assets/Skill/Long huyết.png";
import TrieuSk3 from "../assets/Skill/Long hống.png";
import TrieuSk4 from "../assets/Skill/Long kích.png";
import ValSk1 from "../assets/Skill/Ám khí.png";
import ValSk2 from "../assets/Skill/Chuyến săn mạo hiểm.png";
import ValSk3 from "../assets/Skill/Lời nguyền tử vong.png";
import ValSk4 from "../assets/Skill/Bão đạn.png";
import KriSk1 from "../assets/Skill/Tung cánh.png";
import KriSk2 from "../assets/Skill/Bướm ảo.png";
import KriSk3 from "../assets/Skill/Bão lá.png";
import KriSk4 from "../assets/Skill/Mưa sao băng.png";
import ElsSk1 from "../assets/Skill/Bắn tỉa.png";
import ElsSk2 from "../assets/Skill/Ưng trạm.png";
import ElsSk3 from "../assets/Skill/Viễn trình kích.png";
import ElsSk4 from "../assets/Skill/Giật bắn.png";
import ZatSk1 from "../assets/Skill/Phong sát.png";
import ZatSk2 from "../assets/Skill/Ưng gào.png";
import ZatSk3 from "../assets/Skill/Vòi rồng.png";
import ZatSk4 from "../assets/Skill/Thiên dực.png";
import ButSk1 from "../assets/Skill/Sát thủ.png";
import ButSk2 from "../assets/Skill/Quét kiếm.png";
import ButSk3 from "../assets/Skill/Phi kiếm.png";
import ButSk4 from "../assets/Skill/Ám sát.png";
import ZukSk1 from "../assets/Skill/Võ hồn.png";
import ZukSk2 from "../assets/Skill/Loạn đả bổng.png";
import ZukSk3 from "../assets/Skill/Phi thân kích.png";
import ZukSk4 from "../assets/Skill/Trầm trọng lực.png";
import GilSk1 from "../assets/Skill/Bàn tay vàng.png";
import GilSk2 from "../assets/Skill/Quả đấm vàng.png";
import GilSk3 from "../assets/Skill/Vụ nổ vàng.png";
import GilSk4 from "../assets/Skill/Vương quốc vàng.png";
import AtaSk1 from "../assets/Skill/Biển sâu chúc phúc.png";
import AtaSk2 from "../assets/Skill/Đạp sóng.png";
import AtaSk3 from "../assets/Skill/Bá vương trảo Ata.png";
import AtaSk4 from "../assets/Skill/Thuyền bạch tuột.png";
import ZipSk1 from "../assets/Skill/Béo đô đô.png";
import ZipSk2 from "../assets/Skill/Ác hận.png";
import ZipSk3 from "../assets/Skill/Khí thôn.png";
import ZipSk4 from "../assets/Skill/Lăn long lóc.png";
import AyaSk1 from "../assets/Skill/Linh hồn sóc nhỏ.png";
import AyaSk2 from "../assets/Skill/Nốt nhạc ánh sáng.png";
import AyaSk3 from "../assets/Skill/Rừng sâu bảo hộ.png";
import AyaSk4 from "../assets/Skill/Khúc nhạc rừng sâu.png";
import TorSk1 from "../assets/Skill/Mình đồng da sắc.png";
import TorSk2 from "../assets/Skill/Sừng trâu.png";
import TorSk3 from "../assets/Skill/Dư chấn.png";
import TorSk4 from "../assets/Skill/Đại địa chấn.png";
import AleSk1 from "../assets/Skill/Ma thuật đen.png";
import AleSk2 from "../assets/Skill/Vách ngăn hắc ám.png";
import AleSk3 from "../assets/Skill/Ma trận thống khổ.png";
import AleSk4 from "../assets/Skill/Ngục tù vĩnh hằng.png";
import PaiSk1 from "../assets/Skill/Trảm hồn.png";
import PaiSk2 from "../assets/Skill/Hồn gọi xác.png";
import PaiSk3 from "../assets/Skill/Vong hồn trận.png";
import PaiSk4 from "../assets/Skill/Diệt hồn truy.png";
import AllSk1 from "../assets/Skill/Kiếm gầm.png";
import AllSk2 from "../assets/Skill/Kiếm lưu ngân.png";
import AllSk3 from "../assets/Skill/Kiếm tỏa mệnh.png";
import AllSk4 from "../assets/Skill/Kiếm tất sát.png";
import NatSk1 from "../assets/Skill/Âm hỏa.png";
import NatSk2 from "../assets/Skill/Ác quỷ tụ hội.png";
import NatSk3 from "../assets/Skill/Quả cầu hắc ám.png";
import NatSk4 from "../assets/Skill/Tia sáng tử vong.png";
import GraSk1 from "../assets/Skill/Huyết tế.png";
import GraSk2 from "../assets/Skill/Càn quét.png";
import GraSk3 from "../assets/Skill/Xích ma quái.png";
import GraSk4 from "../assets/Skill/Nuốt chửng.png";
import AirSk1 from "../assets/Skill/Sắc lẻm.png";
import AirSk2 from "../assets/Skill/Phi tiêu.png";
import AirSk3 from "../assets/Skill/Kiếm vũ.png";
import AirSk4 from "../assets/Skill/Long kiếm.png";
import TelSk1 from "../assets/Skill/Sao trời.png";
import TelSk2 from "../assets/Skill/Ưng nhãn.png";
import TelSk3 from "../assets/Skill/Ám tiễn.png";
import TelSk4 from "../assets/Skill/Hỗn mang tiễn.png";
import LauSk1 from "../assets/Skill/Trời phạt.png";
import LauSk2 from "../assets/Skill/Con đường sám hối.png";
import LauSk3 from "../assets/Skill/Đôi cánh thuần khiết.png";
import LauSk4 from "../assets/Skill/Đại phán xét.png";
import CapSk1 from "../assets/Skill/Pháo tự động.png";
import CapSk2 from "../assets/Skill/Đại bác đại liên.png";
import CapSk3 from "../assets/Skill/Pha phản lực pha động lực.png";
import CapSk4 from "../assets/Skill/Mưa liên thanh.png";
import LavSk1 from "../assets/Skill/Đạn liên châu.png";
import LavSk2 from "../assets/Skill/Đạn truy ảnh.png";
import LavSk3 from "../assets/Skill/Khiên phản tốc.png";
import LavSk4 from "../assets/Skill/Đạn thần quang.png";
import VioSk1 from "../assets/Skill/Nạp đạn.png";
import VioSk2 from "../assets/Skill/Đạn xuyên thấu.png";
import VioSk3 from "../assets/Skill/Lựu đạn nổ.png";
import VioSk4 from "../assets/Skill/Pháo đại.png";
import FloSk1 from "../assets/Skill/Xuất chúng.png";
import FloSk2 from "../assets/Skill/Hào hoa.png";
import FloSk3 from "../assets/Skill/Thưởng hoa.png";
import FloSk4 from "../assets/Skill/Tài hoa.png";
import MalSk1 from "../assets/Skill/Ma vương.png";
import MalSk2 from "../assets/Skill/Quỷ kiếm.png";
import MalSk3 from "../assets/Skill/Đoạt hồn.png";
import MalSk4 from "../assets/Skill/Luyện ngục.png";
import VolSk1 from "../assets/Skill/Ma quân.png";
import VolSk2 from "../assets/Skill/Bá vương trảm.png";
import VolSk3 from "../assets/Skill/Bá vương trảo.png";
import VolSk4 from "../assets/Skill/Bất tử ma thân.png";
import AliSk1 from "../assets/Skill/Bước chân thần tốc.png";
import AliSk2 from "../assets/Skill/Vụ nổ thời không.png";
import AliSk3 from "../assets/Skill/Lá chắn thời không.png";
import AliSk4 from "../assets/Skill/Dòng chảy thời không.png";
import IluSk1 from "../assets/Skill/Thần-lực.png";
import IluSk2 from "../assets/Skill/Quả-cầu-ánh-sáng.png";
import IluSk3 from "../assets/Skill/Trục-xuất.png";
import IluSk4 from "../assets/Skill/Thần-trận.png";
import AoiSk1 from "../assets/Skill/Long-lực.png";
import AoiSk2 from "../assets/Skill/Long-trảm.png";
import AoiSk3 from "../assets/Skill/Long-trảo.png";
import AoiSk4 from "../assets/Skill/Long-diệt.png";
import LinSk1 from "../assets/Skill/Phục-kích.png";
import LinSk2 from "../assets/Skill/Nguyệt-quang.png";
import LinSk3 from "../assets/Skill/Nguyệt-vực.png";
import LinSk4 from "../assets/Skill/Nguyệt-ảnh.png";
import SinSk1 from "../assets/Skill/Hoa-máu.png";
import SinSk2 from "../assets/Skill/Ngủ-đông.png";
import SinSk3 from "../assets/Skill/Máu-quỷ.png";
import SinSk4 from "../assets/Skill/Thay-máu.png";
import ErrSk1 from "../assets/Skill/Tay ác ma.png";
import ErrSk2 from "../assets/Skill/Tay lưỡi liềm.png";
import ErrSk3 from "../assets/Skill/Tay đại đao.png";
import ErrSk4 from "../assets/Skill/Mắt ma.png";
import DirSk1 from "../assets/Skill/Giáp năng lượng.png";
import DirSk2 from "../assets/Skill/Kim quang ấn.png";
import DirSk3 from "../assets/Skill/Thiên hoả trận.png";
import DirSk4 from "../assets/Skill/Lô cốt tử quang.png";
import StuSk1 from "../assets/Skill/Thể năng cường hóa.png";
import StuSk2 from "../assets/Skill/Phi đạn tử vong.png";
import StuSk3 from "../assets/Skill/Huyết ảnh ma nhãn.png";
import StuSk4 from "../assets/Skill/Hủy diệt bộc phá.png";
import Bijan1 from "../assets/Skill/Sa mạc thần lực.png";
import Bijan2 from "../assets/Skill/sa mạc mãnh kích.png";
import Bijan3 from "../assets/Skill/sa mạc thần âm.png";
import Bijan4 from "../assets/Skill/sa mạc thần thú.png";
import DieSk1 from "../assets/Skill/Nữ hoàng băng tuyết.png";
import DieSk2 from "../assets/Skill/Sương giá.png";
import DieSk3 from "../assets/Skill/Tuyết liên.png";
import DieSk4 from "../assets/Skill/Bão tuyết.png";
import Arum1 from "../assets/Skill/Linh thú.png";
import Arum2 from "../assets/Skill/Thú kích.png";
import Arum3 from "../assets/Skill/thú sổng.png";
import Arum4 from "../assets/Skill/thú khốn.png";
import QiSk1 from "../assets/Skill/Chân khí hộ thể.png";
import QiSk2 from "../assets/Skill/Truy tinh chưởng.png";
import QiSk3 from "../assets/Skill/Chấn thiên chưởng.png";
import QiSk4 from "../assets/Skill/Hạo nhiên chưởng.png";

export const AOV = [
    {
        id: 1,
        name: "Bright",
        poster: "https://i.pinimg.com/originals/91/73/c2/9173c25b4777dd6824155ee8ac70406d.jpg",
        skill1: {
            name: "Thần lực ánh sáng",
            img: `${briSk1}`,
            delta: "Bright sẽ căn cứ vào cự ly với kẻ địch để tự động quyết định đánh áp sát hay bắn xa. Dưới trạng thái bắn xa, mỗi đòn đánh thường sẽ gây cộng dồn 1 lần trong 5 giây, tối đa cộng dồn 5 lần. Dưới trạng thái cận chiến, mỗi đòn đánh thường sẽ gây sát thương vật lý và khi tấn công kẻ địch mang theo , Bright sẽ gây thêm X số lần thành sát thương chuẩn."
        },
        skill2: {
            name: "Tốc độ quang minh",
            img: `${briSk2}`,
            delta: "Bright bắn ra một luồng ánh sáng theo hướng chỉ định, cộng dồn 1 tầng và gây sát thương vật lý đồng thời có thể dùng nút di chuyển để biến đến vị trị gần đó và phóng tiếp 1 thanh giáo ánh sáng gây lượng sát thương như trên. Bất cứ thanh giáo nào phóng trúng tướng địch đều sẽ giúp bản thân Bright tăng % tốc chạy trong 1.5 giây. Ngoài ra tướng địch đồng thời bị trúng 2 lần sát thương trên sẽ dính thêm 1 tầng , chịu sát thương vật lý và bị choáng 0.75 giây. Nội tại: Kẻ địch bị đánh trúng ở trên sẽ bị đánh dấu trong 5 giây và Bright sẽ nhìn thấy kẻ địch với tầm nhìn chuẩn trong 2 giây."
        },
        skill3: {
            name: "Quang minh phán quyết",
            img: `${briSk3}`,
            delta: "Bright vung đao ánh sáng đột kích vào kẻ địch và gây sát thương vật lý đồng thời 3 đòn đánh thường kế của bản thân được tăng % tốc đánh, hồi máu trong 3 giây.  Nội tại 1: Nếu đánh thường cận chiến vào kẻ địch bị đánh dấu , Bright sẽ xóa hết dấu ấn và được giảm nửa thời gian hồi chiêu 2. Nội tại 2: Bright hạ tướng sẽ lập tức làm mới chiêu 2"
        },
        skill4: {
            name: "Bất tử thánh thân",
            img: `${briSk4}`,
            delta: "Sau khi bật Bất tử thánh thân, tất cả sát thương phải chịu sẽ bị dịch chuyển thời gian sau 3 giây mới bộc phát (cấm dùng chiêu 1). Nếu Bright hạ được kẻ gây sát thương, bản thân sẽ không phải chịu sát thương đến từ kẻ địch đó. Chiêu này kéo dài 6 giây. Mỗi đòn đánh thường xa sẽ mang tính xuyên thấu và đánh dấu lên kẻ địch trong phạm vi. Mỗi đòn đánh thường cận chiến sẽ gây sát thương trong phạm vi và gây X chuyển thành sát thương chuẩn."
        }
    },
    {
        id: 2,
        name: "Richter",
        poster: "https://i.pinimg.com/originals/b7/8a/ae/b78aae364abddba8aa3be87815cf4b54.jpg",
        skill1: {
            name: "Thanh gươm biến ảo",
            img: `${RichSk1}`,
            delta: "Ở các môi trường khác nhau hơn 1.5 giây sẽ giúp cơ thể thích nghi và cường hoá bản thân. Mỗi lần chuyển trạng thái sẽ giúp Richter tăng tốc trong thoáng chốc. Bụi cỏ: Tăng tốc đánh. Dưới sông: Tăng tốc chạy. Trên đường: Tăng miễn thương."
        },
        skill2: {
            name: "Chặt và chém",
            img: `${RichSk2}`,
            delta: "Richter lướt về phía trước gâysát thương vật lý, đồng thời gây hiệu ứng tuỳ theo màu gươm hiện có. Gươm xanh lá: hất tung mục tiêu. Gươm xanh: tăng tầm lướt và gây làm chậm. Gươm đỏ: Hất tung và gây máu tối đa của kẻ địch chưa hết, Richter vung gươm chém tiếp gây sát thương vật lý, rồi biến đòn đánh kế tiếp gây sát thương phép, nếu chiêu thức trúng kẻ địch sẽ được hồi lại ngay lập tức. Hiệu ứng này chỉ xảy ra mỗi 4 giây một lần."
        },
        skill3: {
            name: "Công thủ toàn diện",
            img: `${RichSk3}`,
            delta: "Richter huơ gươm phòng thủ giúp bản thân miễn nhiễm mọi trạng thái khống chế và sát thương trong 0.75 giây (có thể di chuyển bình thường). Vừa hết thời gian, Richter lập tức tấn công gây sát thương vật lý. Tích trữ tối đa 2 cộng dồn Nếu Richter đang có Gươm vàng và chặn thành công một hiệu ứng khống chế thì hắn sẽ gây choáng mục tiêu 1 giây"
        },
        skill4: {
            name: "Vùng diệt quỷ",
            img: `${RichSk4}`,
            delta: "Richter tung chiêu, khắc dấu ấn diệt quỷ lên kẻ địch lân cận, đồng thời tạo ra một vùng gây sát thương chuẩn và làm chậm mỗi 0.5 giây trong 5 giây. Các nạn nhân trúng dấu ấn nếu chịu 5 đợt sát thương từ chiêu thức này sẽ nhận sát thương chuẩn, đồng thời bị câm lặng 1 giây."
        }
    },
    {
        id: 3,
        name: "Ryoma",
        poster: "https://i.pinimg.com/originals/83/90/b2/8390b20cc2e68ee37e06c46098acdda1.jpg",
        skill1: {
            name: "Kiếm quyết",
            img: `${RyoSk1}`,
            delta: "Nội tại: Sau mỗi 5 giây, đòn đánh kế của Ryoma sẽ phóng ra kiếm khí gây sát thương vật lý đồng thời giàm tốc chạy của những kẻ địch trúng chiêu. Nạn nhân trúng rìa chiêu sẽ phải chịu thêm sát thương."
        },
        skill2: {
            name: "Thần hành bất biến",
            img: `${RyoSk2}`,
            delta: "Ryoma nhảy lùi lại để tung một đường kiếm cực mạnh, gây sát thương vật lý lên kẻ địch lân cận. Nếu chiêu thức sát thương tướng địch sẽ khiến thời gian hồi chiêu của Thần hành bách biến được giảm đi. Hiệu ứng không cộng dồn."
        },
        skill3: {
            name: "Nhất kích tất sát",
            img: `${RyoSk3}`,
            delta: "Ryoma rút kiếm chớp nhoáng gây sát thương vật lý lên kẻ địch đầu tiên trúng phải, và 1 phần sát thương đó lên các mục tiêu sau. Các nạn nhân trúng rìa chiêu sẽ bị choáng."
        },
        skill4: {
            name: "Loạn trảm",
            img: `${RyoSk4}`,
            delta: "Ryoma đâm kiếm liên tục 4 lần, mỗi đợt gây sát thương vật lý. Mỗi cú đâm trúng tướng địch giúp Ryoma hồi máu. Đâm nhiều tướng địch không khiến máu hồi nhiều hơn (chiêu thức gây nửa hiệu lực với các đơn vị không phải tướng)."
        }
    },
    {
        id: 4,
        name: "Wukong",
        poster: "https://i.pinimg.com/originals/97/89/c8/9789c85e0f65bf84d1ad4aa0464ee60e.jpg",
        skill1: {
            name: "Vô địch thiên hạ",
            img: `${WuSk1}`,
            delta: "Nội tại: Mỗi lần Ngộ Không tung một chiêu thức, đòn đánh thường tiếp theo của hắn được cường hóa gây thêm sát thương vật lý, đồng thời khiến hắn lập tức áp sát mục tiêu. Đặc biệt Ngộ Không sở hữu sẵn một lượng Tỷ lệ chí mạng."
        },
        skill2: {
            name: "Phân thân thuật",
            img: `${WuSk2}`,
            delta: "Ngộ Không lập tức tiến vào trạng thái tàng hình. Sau khi tung chiêu, Ngộ Không sẽ được tăng tốc chạy trong thời gian ngắn."
        },
        skill3: {
            name: "Cân đẩu vân",
            img: `${WuSk3}`,
            delta: "Ngộ Không cường hóa bản thân giúp tăng giáp vật lý cùng giáp phép trong 1 thời gian, rồi lướt về phía trước sẵn sàng đại chiến 500 hiệp."
        },
        skill4: {
            name: "Gậy như ý",
            img: `${WuSk4}`,
            delta: "Ngộ Không vung gậy tấn công kẻ địch xung quanh, gây sát thương vật lý và làm choáng kẻ địch. Ngộ Không có thể kích hoạt chiêu thức một lần nữa trong 5 giây để có thể giải trừ Hiệu ứng giảm tốc của bản thân và tàng hình, gia tăng tốc chạy trong thời gian ngắn."
        }
    },
    {
        id: 5,
        name: "Quillen",
        poster: "https://i.pinimg.com/originals/02/1d/1e/021d1eec93af4b25bce2f14cf35a8d4b.jpg",
        skill1: {
            name: "Đánh lén",
            img: `${QuiSk1}`,
            delta: "Những đòn đánh và chiêu thức tấn công từ phía sau kẻ địch chắc chắn gây chí mạng (tối đa 1500 lên kẻ địch không phải tướng). Tuy nhiên sát thương chí mạng khởi điểm của hắn chỉ là 125% (tăng 0.5% theo mỗi 0.5% tỷ lệ chí mạng Quillen có) Tấn công trước mặt chắc chắn không chí mạng"
        },
        skill2: {
            name: "Chém đôi",
            img: `${QuiSk2}`,
            delta: "Quillen chém chớp nhoáng hai lần theo hướng chỉ định, gây sát thương vật lý."
        },
        skill3: {
            name: "Đoản mệnh",
            img: `${QuiSk3}`,
            delta: "Quillen lướt đi, khi đến đích lập tức tấn công kẻ địch gây sát thương vật lý và đánh dấu nó trong 10 giây (chỉ có thể đánh dấu một kẻ địch mỗi lần). Mỗi lần Quillen công kích nạn nhân bị đánh dấu sẽ làm chậm tốc chạy trong 1 giây, và giảm 1 giây hồi chiêu này. Kẻ địch chịu dấu ấn sẽ bị giảm sát thương gây ra lên Quillen."
        },
        skill4: {
            name: "Ẩn sát",
            img: `${QuiSk4}`,
            delta: "Quillen lăn một vòng, sau đó tàng hình trong 3 giây, tăng tốc chạy và hồi máu mỗi 0.5 giây. Suốt thời gian này, nếu Quillen tấn công kẻ địch sẽ hiện hình và cường hoá bản thân trong 3 giây kế tiếp. Cường hoá: Quillen nhận công vật lý, và tốc chạy mỗi khi gây sát thương lên kẻ địch. Nội tại: Phụ hoặc hạ gục tướng địch sẽ làm mới hồi chiêu của toàn bộ kỹ năng"
        }
    },
    {
        id: 6,
        name: "Nakroth",
        poster: "https://i.pinimg.com/originals/9b/ac/7a/9bac7a36c8c55e967361f9b38ed9c36d.jpg",
        skill1: {
            name: "Thẩm phán oai nghiêm",
            img: `${NakSk1}`,
            delta: "Nội tại: Mỗi đòn đánh thường thứ 4 sẽ hất văng mục tiêu. Tung chiêu trúng địch hoặc dùng Nguồn cơn rắc rối sẽ tăng tốc đánh."
        },
        skill2: {
            name: "Bồi thẩm đoàn",
            img: `${NakSk2}`,
            delta: "Nakroth xông về phía trước, hất văng mục tiêu gây sát thương vật lý. Kỹ năng này có thể tung ra một lần nữa miễn phí trong vòng 5 giây."
        },
        skill3: {
            name: "Nguồn cơn rắc rối",
            img: `${NakSk3}`,
            delta: "Nakroth biến về phía sau và biến đòn tấn công vật lý tiếp theo của mình trong 3 giây thành đòn quét gây sát thương vật lý."
        },
        skill4: {
            name: "Gươm hành quyết",
            img: `${NakSk4}`,
            delta: "Nakroth vung lưỡi gươm của mình lên những kẻ thù trong phạm vi gây sát thương vật lý mỗi lần. Hắn không thể bị khống chế. Đòn đánh cuối cùng sẽ hất văng kẻ địch ."
        }
    },
    {
        id: 7,
        name: "Veres",
        poster: "https://i.pinimg.com/originals/fc/1a/47/fc1a47e914074d1a3ed4730496b2e2ea.jpg",
        skill1: {
            name: "Huyết xích",
            img: `${VerSk1}`,
            delta: "Các đòn đánh thường trúng đích giúp Veres tích lũy 1 điểm nội tại Huyết xích; khi đạt đủ 4 điểm tích lũy Veres sẽ tung Huyết xích tấn công tất cả kẻ địch lân cận, gây sát thương vật lý; nếu có tướng địch trúng đòn, Veres hồi lại 1 phần sát thương gây ra thành máu. Đặc biệt Veres còn được giảm 1 giây hồi Song xích & Xiềng xích, và 2 giây hồi Đoạt mệnh xích. Chưa hết, suốt thời gian tung Huyết xích Veres có thể thoải mái di chuyển, và còn được tăng kháng hiệu ứng."
        },
        skill2: {
            name: "Song xích",
            img: `${VerSk2}`,
            delta: "Veres phóng xích tách làm hai sợi tấn công kẻ địch gây sát thương vật lý. Nạn nhân xấu số trúng cả hai sợi xích sẽ bị choáng 1 giây. Chưa hết, tung xích trúng tướng địch giúp Veres nhận một điểm tích lũy Huyết xích."
        },
        skill3: {
            name: "Xiềng xích",
            img: `${VerSk3}`,
            delta: "Veres phóng xích tấn công kẻ địch gây sát thương vật lý. Đặc biệt sợi xích sẽ đẩy lùi kẻ địch nếu chúng đang ở gần Veres, hoặc kéo kẻ địch về trước mặt nếu chúng đang ở xa Veres; trong cả hai trường hợp nạn nhân đều sẽ bị choáng ngay sau đó. Chưa hết, tung xích trúng tướng địch giúp Veres nhận một điểm tích lũy Huyết xích."
        },
        skill4: {
            name: "Đoạt mệnh xích",
            img: `${VerSk4}`,
            delta: "Veres nhảy đến phía trước triệu hồi vô số xích trồi lên từ mặt đất tấn công những kẻ địch trong vùng ảnh hưởng, gây máu đã mất của mục tiêu sát thương chuẩn Tung chiêu trúng tướng địch giúp Veres tiến vào trạng thái Cuồng huyết: tăng tốc đánh, công vật lý, xuyên giáp trong 4 giây (nếu kết liễu tướng địch sẽ tăng thành 10 giây). Suốt thời gian này nếu nội tại được kích hoạt tung Huyết xích trúng một tướng địch sẽ giúp tăng thêm 2 giây trạng thái Cuồng huyết"
        }
    },
    {
        id: 8,
        name: "Enzo",
        poster: "https://i.pinimg.com/originals/d8/e3/a8/d8e3a8d57a91b9903ddab617670a4573.jpg",
        skill1: {
            name: "Tín niệm",
            img: `${EnzSk1}`,
            delta: "Enzo tiến vào trạng thái Tín niệm, được tăng phúc năng lực thần thánh lên vũ khí, gây 100% sát thương vật lý lên địch ở gần. Đánh xa gây thêm 35% sát thương, đánh trúng tướng địch giúp bản thân tăng tốc chạy (hiệu quả phụ thuộc vào Truy bức)"
        },
        skill2: {
            name: "Truy bức",
            img: `${EnzSk2}`,
            delta: "Enzo lướt nhanh và được tăng công vật lý. Nếu đánh trúng địch ở xa sẽ làm chậm địch và tăng tốc chạy cho bản thân. Nếu kích hoạt Câu hồn, Truy bức khiến mục tiêu chịu Câu hồn bị kéo theo một đoạn nhỏ theo hướng Enzo di chuyển"
        },
        skill3: {
            name: "Câu hồn",
            img: `${EnzSk3}`,
            delta: "Enzo tụ lực rồi tung theo hướng chỉ định, gây sát thương vật lý đồng thời trói buộc kẻ địch thứ nhất khi tỏa liêm quay về và gây hiệu ứng Câu hồn; tụ lực càng lâu tỏa liêm bay càng xa, tụ lực nhiều nhất 4 giây. Khi tụ lực được tăng 30% tốc chạy, hủy tụ lực khiến Câu hồn giảm 50% thời gian hồi chiêu; khi Câu hồn được kích hoạt, Enzo có thể tiếp tục dùng chiêu này kéo địch về sau đồng thời xóa hiệu ứng Câu hồn. Dưới trạng thái Câu hồn, Enzo được tăng sát thương và giảm sát thương phải chịu từ tướng địch đang đánh; nếu kẻ địch tử vong, Câu hồn giảm 80% thời gian hồi chiêu."
        },
        skill4: {
            name: "Hành quyết",
            img: `${EnzSk4}`,
            delta: "Enzo lướt cực nhanh theo tỏa liêm hiện phía sau lưng địch bị dính Câu hồn, gây sát thương vật lý lên các mục tiêu trên đường lướt; trong quá trình lướt Enzo được miễn thương 50%; Hành quyết chỉ có thể dùng khi mục tiêu bị dính Câu hồn. Nội tại: Enzo diệt hoặc phụ diệt tướng địch đều kích hoạt trạng thái máy chém tăng tốc chạy, tốc đánh kéo dài 5 giây (tốc đánh tốc chạy giảm theo thời gian)"
        }
    },
    {
        id: 9,
        name: "Kaine",
        poster: "https://i.pinimg.com/originals/4c/95/96/4c9596895943b0924f7d8b19272fc4b3.jpg",
        skill1: {
            name: "Truy nã",
            img: `${KaiSk1}`,
            delta: "Nội tại: Kaine tàng hình khi xung quanh không có địch"
        },
        skill2: {
            name: "Huyết luân",
            img: `${KaiSk2}`,
            delta: "Gây sát thương cho địch xung quanh. Kẻ địch còn ít máu nhất sẽ nhận thêm sát thương."
        },
        skill3: {
            name: "Huyết kiếm",
            img: `${KaiSk3}`,
            delta: "Phóng huyết ảnh kiếm khí theo hướng kẻ địch, đánh dấu và làm chậm chúng. Trong thời gian đánh dấu, Kaine sẽ làm choáng địch nếu đánh trúng chúng."
        },
        skill4: {
            name: "Huyết kích",
            img: `${KaiSk4}`,
            delta: "Lướt về trước và gây sát thương trên đường di chuyển. Kaine được miễn khống và không bị khóa mục tiêu khi đang lướt."
        }
    },
    {
        id: 10,
        name: "Veera",
        poster: "https://i.pinimg.com/originals/99/ba/37/99ba3794b34734800cae4d701a6835a6.png",
        skill1: {
            name: "Mê hoặc",
            img: `${VeeSk1}`,
            delta: "Nội tại: Các mục tiêu dính sát thương bởi các kỹ năng bị giảm giáp phép tối đa 3 lần cộng dồn. Mỗi khi Veera hạ hoặc phụ một vị tướng, cô được giảm 25% hồi chiêu của toàn bộ kĩ năng."
        },
        skill2: {
            name: "Dơi địa ngục",
            img: `${VeeSk2}`,
            delta: "Veera ném ra một con Dơi Địa Ngục gây ra sát thương phép."
        },
        skill3: {
            name: "Hôn gió",
            img: `${VeeSk3}`,
            delta: "Nụ hôn của Veera gây sát thương cho kẻ thù với sát thương phép, và choáng nạn nhân trong thời gian ngắn."
        },
        skill4: {
            name: "Tiểu quỷ",
            img: `${VeeSk4}`,
            delta: "Veera triệu hồi tối đa 5 Tiểu Quỷ để tấn công những kẻ thù xung quanh. Mỗi Tiểu Quỷ gây 1 lượng sát thương phép. Nếu Tiểu Quỷ tấn công cùng một mục tiêu, đòn đánh thứ hai trở đi chỉ gây ra 50% sát thương."
        }
    },
    {
        id: 11,
        name: "Murad",
        poster: "https://i.pinimg.com/originals/a9/ff/b9/a9ffb9417bc0f26ee38d5bbb187e19e1.jpg",
        skill1: {
            name: "Ảnh hồn",
            img: `${MurSk1}`,
            delta: "Nội tại: Mỗi đòn đánh thường trúng đích giúp Murad cộng dồn 1 Ảnh hồn và tăng xuyên giáp. Đủ 4 cộng dồn sẽ phá phong ấn của Ảo ảnh trảm trong 5 giây."
        },
        skill2: {
            name: "Tàn ảnh đao",
            img: `${MurSk2}`,
            delta: "Murad lướt đi gây sát thương vật lý và làm choáng lên những nạn nhân trúng chiêu. Chiêu thức có thể tung ra 3 lần, đặc biệt ở lần thứ ba Murad sẽ quay trở về vị trí ban đầu của bản thân."
        },
        skill3: {
            name: "Vô ảnh cực",
            img: `${MurSk3}`,
            delta: "Murad tạo ra một vùng không gian gây sát thương vật lý lên tất cả nạn nhân bên trong phạm vi ảnh hưởng. Những kẻ địch dại dột chạm phải biên giới vùng không gian này sẽ phải chịu thêm sát thương vật lý, và bị làm chậm tốc chạy trong 2 giây, kèm giảm giáp trong 3 giây. Ngay thời điểm kích hoạt chiêu thức Murad sẽ trở nên không thể bị tấn công hoặc chọn làm mục tiêu."
        },
        skill4: {
            name: "Ảo ảnh trảm",
            img: `${MurSk4}`,
            delta: "Murad tấn công liên tục 5 đòn đánh lên mọi kẻ địch trong vùng ảnh hưởng, gây sát thương vật lý mỗi đòn. Suốt thời gian tung chiêu, Murad không thể bị tấn công hoặc chọn làm mục tiêu. Nếu như có nhiều hơn một tướng địch trong vùng ảnh hưởng sẽ làm giảm sát thương và tối đa giảm 20%."
        }
    },
    {
        id: 12,
        name: "Liliana",
        poster: "https://i.pinimg.com/originals/2e/f9/97/2ef9977f23f2e9e4fe64946bb5f571e6.jpg",
        skill1: {
            name: "Yêu hồ",
            img: `${LilSk1}`,
            delta: "Nội tại: Dạng người: Trong trạng thái loài người Liliana sẽ đánh xa. Dạng hồ ly: Tăng giáp và giáp phép và tốc chạy. Đồng thời, đòn đánh thường gây sát thương phép."
        },
        skill2: {
            name: "Hồ quang lực",
            img: `${LilSk2}`,
            delta: "Khi tung chiêu trong dạng người Liliana ngưng tụ ma lực gây sát thương phép lên những kẻ địch trong phạm vi ảnh hưởng. Nếu có 2 tướng địch trúng chiêu trở lên, đòn đánh thường kế tiếp của Liliana sẽ được cường hóa gây sát thương phép dựa trên máu tối đa mục tiêu. Khi ở dạng hồ ly sẽ thành Hồ Vĩ Kích: Liliana vẫy đuôi tấn công kẻ địch phía trước, gây sát thương phép, đồng thời khiến lần đánh thường kế trở thành chuỗi liên hoàn 3 đòn, mỗi đòn gây sát thương phép, kèm hiệu ứng nhảy vồ đến mục tiêu."
        },
        skill3: {
            name: "Hồ quang đạn",
            img: `${LilSk3}`,
            delta: "Khi tung chiêu ở dạng người, Liliana bắn ra một luồng đạn ma lực, thứ sẽ phát nổ khi trúng đích gây sát thương phép và 0.75 giây choáng lên những kẻ địch trong phạm vi hiệu lực. Khi ở dạng hồ ly chiêu thức này sẽ hóa thành Vũ Điệu Yêu Hồ: Liliana lướt về hướng chỉ định gây sát thương phép lên những kẻ địch trúng chiêu. Nếu có nạn nhân là tướng địch, Liliana có thể tung chiêu lần nữa, bắn ra đạn linh lực đuối theo tấn công kẻ địch và gây sát thương phép trong phạm vi."
        },
        skill4: {
            name: "Biến ảnh hoán hình",
            img: `${LilSk4}`,
            delta: "Dạng người: Liliana lướt đi và hóa thành hồ ly gây sát thương phép lên những kẻ địch trúng chiêu, đồng thời làm chậm tốc chạy trong 2 giây. Khi lướt Liliana không thể bị chọn làm mục tiêu, đồng thời tăng giáp và giáp phép cùng công phép trong 2.5 giây. Dạng cáo: Liliana lướt đi và hóa thành người đồng thời để lại pháp trận tại điểm đến và đi khiến các kẻ địch bên trong bị giảm tốc chạy. Sau 1 giây, pháp trận nổ tung gây sát thương phép. Suốt thời gian lướt đi, Liliana không thể bị chọn làm mục tiêu đồng thời tăng công phép trong 2.5 giây."
        }
    },
    {
        id: 13,
        name: "Hayate",
        poster: "https://i.pinimg.com/originals/aa/5f/7e/aa5f7e90105729f872caefcc003990bf.jpg",
        skill1: {
            name: "Phản ứng dây chuyền",
            img: `${HaySk1}`,
            delta: "Nội tại: Các đòn đánh thường trúng đích khiến một nạn nhân lân cận mục tiêu chính chịu sát thương vật lý, bù lại Hayate gây giảm sát thương lên quái rừng (tăng dần lại theo cấp tướng). Đặc biệt sau 6 lần công kích (tính cả đánh thường lẫn chiêu thức) trúng đích cùng mục tiêu, Hayate sẽ được hồi 40 nội năng, đồng thời khiến các đợt tấn công trong vòng 4 giây kế gây thêm sát thương chuẩn lên nạn nhân."
        },
        skill2: {
            name: "Chuỗi phi tiêu",
            img: `${HaySk2}`,
            delta: "Hayate liên tục phóng phi tiêu về phía trước và được tăng tốc chạy suốt thời gian này; mỗi phi tiêu gây sát thương vật lý đồng thời kích hoạt nội tại. Đặc biệt phi tiêu có thể xuyên thấu các đơn vị không phải tướng, bù lại gây giảmsát thương sau mỗi đơn vị xuyên qua. Nạn nhân trúng phi tiêu giúp Hayate hồi 10 nội năng, mỗi phi tiêu chỉ hồi một lần. Ở các mốc 0%/75%/150% tốc đánh Hayate sẽ tung ra 5/7/9 phi tiêu."
        },
        skill3: {
            name: "Ảnh biến",
            img: `${HaySk3}`,
            delta: "Hayate lướt đi theo hướng chỉ định (có thể vượt địa hình). Nội tại: Hayate được tăng sát thương gây ra và tốc chạy khi có tướng địch trong vòng 5m quanh bản thân."
        },
        skill4: {
            name: "Bão phi tiêu",
            img: `${HaySk4}`,
            delta: "Hayate biến đến điểm đã chọn đồng thời liên tục ném phi tiêu công kích các kẻ địch lân cận, gây sát thương vật lý và kích hoạt nội tại. Ở các mốc 0%/75%/150% tốc đánh Hayate sẽ tung ra 10/13/16 đợt công kích."
        }
    },
    {
        id: 14,
        name: "Tulen",
        poster: "https://i.pinimg.com/originals/3f/71/1a/3f711a6e277f67be5e037ec8cb448436.jpg",
        skill1: {
            name: "Lôi điện",
            img: `${TulSk1}`,
            delta: "Nội tại: Chiêu thức trúng đích giúp Tulen tích lũy dấu ấn Lôi Điện. Khi đạt tới 5 điểm Tulen sẽ tạo ra 5 luồng sét quanh bản thân, công kích kẻ địch lân cận (ưu tiên tướng) gây ra sát thương phép mỗi luồng. Nếu 1 mục tiêu bị nhiều luồng sét tấn công trong 1 giây, sát thương sét sẽ bị giảm (sét đánh không tấn công các đơn vị quái rừng không trong trạng thái chiến đấu)."
        },
        skill2: {
            name: "Lôi quang",
            img: `${TulSk2}`,
            delta: "Tulen bắn ra 3 tia sét về phía trước. Mỗi tia trúng đích gây sát thương phép. Mục tiêu trúng nhiều tia sẽ chịu ít sát thương hơn từ các tia khác. Mỗi tia chỉ có thể gây 1 điểm hiệu ứng Lôi điện."
        },
        skill3: {
            name: "Lôi động",
            img: `${TulSk3}`,
            delta: "Tulen biến ảo cực nhanh gây ra sát thương phép tại cả vùng biến đến và biến đi (nạn nhân chịu sát thương cả hai lượt biến chỉ nhận 50% sát thương ở lượt sau). Nếu kẻ địch trong vòng 5 giây liên tục chịu ảnh hưởng bởi chiêu này sẽ bị làm chậm 90% tốc chạy giảm dần, Ngoài ra mỗi mục tiêu trúng chiêu sẽ chỉ phải chịu 1 điểm hiệu ứng Lôi điện. Chiêu thức tích lũy tối đa 3 lần, thời gian hồi giữa hai lần thi triển liên tiếp là 2 giây."
        },
        skill4: {
            name: "Lôi điểu",
            img: `${TulSk4}`,
            delta: "Tulen có thể vừa di chuyển, vừa tung chiêu triệu hồi một chú chim điện tấn công mục tiêu chỉ định gây sát thương phép, đồng thời tự tăng cho bản thân 1 dấu ấn Lôi điện. Nếu chim điện trực tiếp hạ gục tướng địch sẽ lập tức kích hoạt nội tại Lôi điện, đồng thời giảm mạnh thời gian hồi Lôi điểu. Chim điện có thể bị cản lại bởi những tướng địch khác, còn đối với các đơn vị không phải tướng sẽ phải chịu sát thương và chịu đẩy lùi."
        }
    },
    {
        id: 15,
        name: "Omen",
        poster: "https://i.pinimg.com/originals/3a/b0/66/3ab066a6ae3e0127d26caa2feca4d464.jpg",
        skill1: {
            name: "Sát khí",
            img: `${OmeSk1}`,
            delta: "Nội tại: Các đòn đánh thường trúng đích giúp Omen nhận một điểm tích lũy sát khí. Đạt đủ 5 điểm sẽ tiến vào trạng thái cường hóa, giúp tăng tốc chạy và tốc đánh, đồng thời đòn đánh gây thêm sát thương chuẩn và giảm thời gian hồi chiêu của chiêu 1 và chiêu 2 đi 1 giây. Hiệu ứng kéo dài 5 giây. Mỗi đòn đánh thứ ba của Omen sẽ tấn công hai lần, gây thêm công vật lý. Bộ đếm sẽ đếm lại khi Omen đủ 5 điểm sát khí hoặc khi kết thúc trạng thái cường hóa."
        },
        skill2: {
            name: "Sát kiếm",
            img: `${OmeSk2}`,
            delta: "Omen tung kiếm kéo kẻ địch phía trước lại gần bản thân , gây sát thương vật lý và làm chậm tốc chạy của nạn nhân."
        },
        skill3: {
            name: "Sát niệm",
            img: `${OmeSk3}`,
            delta: "Khao khát muốn tiêu diệt tất cả bao phủ lấy Omen, giúp hắn tăng miễn thương và tốc chạy trong 2 giây. Suốt thời gian này, các đòn đánh thường của tướng địch lên Omen sẽ bị bắn ngược về chính chủ, gây sát thương vật lý và làm chậm tốc chạy của nạn nhân (kèm hiệu ứng đánh thường từ Omen). Mỗi kẻ địch chỉ chịu bắn ngược một lần. Đòn bắn ngược làm tăng sát khí."
        },
        skill4: {
            name: "Sát vực",
            img: `${OmeSk4}`,
            delta: "Omen lao đến tướng địch đầu tiên trúng chiêu gây sát thương vật lý, đồng thời tạo ra một đấu trường tử vong khiến mục tiêu bị giảm sát thương gây ra, và không thể trốn thoát trong 5 giây."
        }
    },
    {
        id: 16,
        name: "Triệu Vân",
        poster: "https://i.pinimg.com/originals/1d/12/8f/1d128f20f6d78917f144490342736ca6.jpg",
        skill1: {
            name: "Long tướng",
            img: `${TrieuSk1}`,
            delta: "Nội tại: Mỗi điểm hạ hoặc phụ tăng cho Triệu Vân một ít công vật lý. Cộng dồn 20 lần. Mỗi một điểm hạ hoặc phụ hồi cho Triệu Vân 5% máu tối đa"
        },
        skill2: {
            name: "Long huyết",
            img: `${TrieuSk2}`,
            delta: "Triệu Vân cường hóa bản thân giúp loại bỏ mọi trạng thái bất lợi đang gánh chịu, đồng thời tăng 80% tốc chạy trong thời gian ngắn. Đòn đánh thường kế tiếp sẽ được cường hóa, gây thêm sát thương vật lý lên những kẻ địch lân cận, khiến chúng bị làm chậm 50% tốc chạy trong thời gian ngắn."
        },
        skill3: {
            name: "Long hống",
            img: `${TrieuSk3}`,
            delta: "Triệu Vân quét thương, gây sát thương vật lý lên những kẻ địch lân cận, đồng thời giúp hắn tăng tốc đánh và hút máu."
        },
        skill4: {
            name: "Long kích",
            img: `${TrieuSk4}`,
            delta: "Triệu Vân nện thương lên mục tiêu, gây sát thương chuẩn kèm hiệu ứng hất văng thoáng chốc. Ngoài ra Triệu Vân còn nhận miễn thương, đặc biệt các đòn đánh thường gây thêm sát thương chuẩn. Hiệu ứng kéo dài 5 giây."
        }
    },
    {
        id: 17,
        name: "Raz",
        poster: "https://i.pinimg.com/originals/a7/84/45/a784459b3960d992a597a3d3635f4f3d.jpg",
        skill1: {
            name: "Đấm và lách",
            img: `${RazSk1}`,
            delta: "Nội tại - Lách: Sau khi tung chiêu thức Raz có thể lập tức lách bước với tốc độ di chuyển cực cao. Nội tại - Đấm: Cú đấm đầu tiên và cú đấm thứ ba gây sát thương phép kèm hiệu ứng đẩy lùi địch."
        },
        skill2: {
            name: "Cú đấm thăng hoa",
            img: `${RazSk2}`,
            delta: "Raz lao tới tung một cú đấm móc đầy uy lực lên những kẻ địch trong vùng ảnh hưởng, gây sát thương phép kèm hiệu ứng hất tung. Chiêu thức tung trúng đích giúp hồi nội năng."
        },
        skill3: {
            name: "Cú đấm chân không",
            img: `${RazSk3}`,
            delta: "Raz vung tay mạnh đến mức sức gió của cú đấm gây sát thương phép kèm hiệu ứng làm chậm tốc chạy và giảm giáp phép lên kẻ địch đầu tiên trúng phải. Chiêu thức tung trúng đích giúp hồi nội năng."
        },
        skill4: {
            name: "Tả xung hữu đột",
            img: `${RazSk4}`,
            delta: "Raz ủi người về phía trước tung ra một cú đấm bộc phá, gây sát thương phép, kèm hiệu ứng đẩy lùi lên kẻ trúng chiêu. Chiêu trúng đích giúp hồi nội năng."
        }
    },
    {
        id: 18,
        name: "Valhein",
        poster: "https://i.pinimg.com/originals/ee/a8/22/eea8227b18ab2d0691f44d5ffd79d89a.jpg",
        skill1: {
            name: "Ám khí",
            img: `${ValSk1}`,
            delta: "Nội tại: Mỗi đòn đánh thường thứ ba bắn một đoản kiếm ngẫu nhiên kèm hiệu ứng đặc biệt. Valhein nhận một điểm cộng dồn 'Thợ săn' giúp tăng tốc chạy trong thời gian ngắn, cộng dồn tối đa 6 lần."
        },
        skill2: {
            name: "Chuyến săn mạo hiểm",
            img: `${ValSk2}`,
            delta: "Valhein ném một phi tiêu đặc biệt vào kẻ thù trong phạm vi, gây sát thương phép, đồng thời giúp tăng một điểm hiệu ứng 'Thợ săn'."
        },
        skill3: {
            name: "Lời nguyền tử vong",
            img: `${ValSk3}`,
            delta: "Valhein ném một phi tiêu hoàng kim vào mục tiêu, gây sát thương phép, và làm choáng mục tiêu, đồng thời giúp tăng một điểm hiệu ứng 'Thợ săn'."
        },
        skill4: {
            name: "Bão đạn",
            img: `${ValSk4}`,
            delta: "Valhein bắn sáu viên đạn bạc gây sát thương phép lên kẻ địch. Mỗi phát đạn trúng đích giúp tăng 1 cộng dồn Ám khí và tốc đánh. Nếu như kẻ địch trúng nhiều hơn một viên đạn, kẻ đó chỉ phải chịu ít sát thương hơn từ viên thứ hai."
        }
    },
    {
        id: 19,
        name: "Krixi",
        poster: "https://i.pinimg.com/originals/c2/df/5c/c2df5c2584e5c15008bd9c3f3f5f7acc.jpg",
        skill1: {
            name: "Tung cánh",
            img: `${KriSk1}`,
            delta: "Nội tại: Khi tung kĩ năng trúng đích, tốc chạy của cô sẽ được tăng lên trong thời gian ngắn."
        },
        skill2: {
            name: "Bướm ảo",
            img: `${KriSk2}`,
            delta: "Krixi tung ra một ảnh ảo bươm bướm bay đi bay về gây sát thương phép mỗi lượt. Mỗi đơn vị trúng đích sẽ giảm sát thương lên các đơn vị sau đó, tối đa giảm còn 40%."
        },
        skill3: {
            name: "Bão lá",
            img: `${KriSk3}`,
            delta: "Krixi kêu gọi sức mạnh thiên nhiên tấn công kẻ địch, hất tung chúng và gây sát thương phép."
        },
        skill4: {
            name: "Mưa sao băng",
            img: `${KriSk4}`,
            delta: "Trong vòng 5 giây, Krixi gọi xuống mưa sao băng công kích kẻ địch lân cận, gây sát thương phép mỗi lần rơi trúng. Mỗi kẻ địch chỉ có thể bị trúng tối đa 4 lần. Krixi được tăng tốc chạy khi đang sử dụng chiêu cuối."
        }
    },
    {
        id: 20,
        name: "Elsu",
        poster: "https://i.pinimg.com/originals/34/c2/98/34c298ae80de05d4c5381e86005a25b6.jpg",
        skill1: {
            name: "Bắn tỉa",
            img: `${ElsSk1}`,
            delta: "Các đòn đánh thường của Elsu gây sát thương vật lý, tuy nhiên sẽ không thể gây chí mạng. Thay vào đó, với mỗi 1% chí mạng Elsu sở hữu, anh sẽ được tăng 3 công vật lý. Nội tại: Khi rời khỏi giao tranh 5 giây và đứng gần địa hình vách núi, Elsu sẽ nguỵ trang trong thời gian ngắn, gia tăng tốc độ di chuyển và trở nên mờ nhạt đi"
        },
        skill2: {
            name: "Ưng trạm",
            img: `${ElsSk2}`,
            delta: "Kích hoạt: Elsu cài đặt một thiết bị Ưng trạm tại chỗ giúp cung cấp tầm nhìn trong phạm vi 600 - 1000 khoảng cách (tăng theo cấp tướng). Ưng trạm tồn tại trong 300 giây, có thể tích trữ tối đa 2 cái, và đặt tối đa 3 cái trên bản đồ. Khi đứng trong phạm vi của Ưng trạm, Elsu được tăng thêm sát thương mỗi đòn bắn lên quái rừng (tối đa 250), nhưng sẽ bị vô hiệu hoá khi tướng địch giẫm lên. Nội tại: Đứng tại chỗ mỗi giây giúp Elsu tăng xuyên giáp (tăng theo cấp tướng), tối đa cộng dồn 5 lần. Nếu Elsu di chuyển sẽ không được làm mới nội tại nữa."
        },
        skill3: {
            name: "Viễn trình kích",
            img: `${ElsSk3}`,
            delta: "Elsu nhắm bắn gây sát thương vật lý kèm làm chậm tốc chạy lên tướng đầu tiên trúng phải. Elsu cần ngắm bắn trong 2 giây để gia tăng khoảng cách và độ chính xác."
        },
        skill4: {
            name: "Giật bắn",
            img: `${ElsSk4}`,
            delta: "Elsu lộn ra phía sau rồi lập tức bắn về phía trước gây sát thương vật lý và làm chậm tốc chạy của nạn nhân. Khi đáp đất Elsu được tăng tốc chạy trong 2 giây, nhưng nếu tung chiêu hoặc đánh thường sẽ lập tức giải trừ hiệu ứng này"
        }
    },
    {
        id: 21,
        name: "Zata",
        poster: "https://i.pinimg.com/originals/58/68/a1/5868a131cf0c9f075a702542846addc7.jpg",
        skill1: {
            name: "Phong sát",
            img: `${ZatSk1}`,
            delta: "Nội tại Phong sát gây sát thương lên mục tiêu giúp Zata giảm hồi chiêu cuối 2 giây. Nếu đánh trúng tướng địch tăng giảm hồi chiêu gấp đôi; hiệu ứng Phong sát không cộng dồn. Nếu trong quá trình tung chiêu cuối kích hoạt nội tại thì hiệu ứng này sẽ được làm mới vào lúc hồi chiêu cuối"
        },
        skill2: {
            name: "Ưng gào",
            img: `${ZatSk2}`,
            delta: "Zata bắn ra một phi đạn giảm dần tốc độ. Kẻ địch trúng đòn sẽ phải chịu 225/270/315/360/405/450 (+0.3 công phép) sát thương phép. Nếu bay đến vị trí xa nhất, phi đạn sẽ nổ tung gây sát thương phép thuật lần nữa."
        },
        skill3: {
            name: "Vòi rồng",
            img: `${ZatSk3}`,
            delta: "Zata tạo một cơn lốc tại điểm chỉ định gây 300/360/420/480/540/600 (+0.3 công phép) sát thương phép và làm chậm địch trong 2 giây. Cơn lốc sau khi sinh ra sẽ quay về vị trí Zata đang đứng ở thời điểm tung chiêu. (Chiêu này mỗi 10 - 8 giây sẽ dự trữ 1 lần, tối đa tích trữ 2 lần. Hồi chiêu giảm theo cấp chiêu và trang bị)"
        },
        skill4: {
            name: "Thiên dực",
            img: `${ZatSk4}`,
            delta: "Zata lướt về phía trước gây 300/375/450 (+0.25 công phép) sát thương phép lên những kẻ địch trên đường lướt. Nếu trong quá trình lướt gặp phải các chiêu khác của bản thân hoặc kẻ địch, trong 3 giây kế Zata sẽ được sử dụng nút di chuyển để tiến hành xung kích (tối đa xung kích 3 lần, khi dừng có thể đánh thường hoặc tung chiêu. Theo số lần xung kích mà giảm hồi chiêu từ 1 lần 25%, 2 lần 50%, 3 lần 75%). Nếu Zata hoàn tất đủ 3 lần xung kích, hắn sẽ kích hoạt nội tại, không bị chọn làm mục tiêu và gây 100/125/150 (+0.1 công phép) (+2% máu tối đa kẻ địch) sát thương phép liên tục lên 1 tướng địch ở gần."
        }
    },
    {
        id: 22,
        name: "Butterfly",
        poster: "https://i.pinimg.com/originals/05/ae/34/05ae349a42fa1731a182084767e3202c.jpg",
        skill1: {
            name: "Sát thủ",
            img: `${ButSk1}`,
            delta: "Hạ hoặc phụ sẽ làm mới toàn bộ thời gian hồi chiêu"
        },
        skill2: {
            name: "Quét kiếm",
            img: `${ButSk2}`,
            delta: "Butterfly quét kiếm, gây sát thương vật lý, xoá làm chậm đang phải gánh chịu, đồng thời tăng tốc chạy bản thân."
        },
        skill3: {
            name: "Phi kiếm",
            img: `${ButSk3}`,
            delta: "Butterfly phóng kiếm chớp nhoáng gây sát thương vật lý lên những nạn nhân trúng đòn theo đường thẳng. Đồng thời, Butterfly được tăng tốc đánh."
        },
        skill4: {
            name: "Ám sát",
            img: `${ButSk4}`,
            delta: "Butterfly xuất hiện phía sau kẻ địch có lượng máu thấp nhất (ưu tiên tướng) và ám sát nạn nhân, gây sát thương vật lý. Đồng thời, Butterfly được tăng miễn thương trong và mục tiêu sẽ bị đánh dấu. Khi kết thúc đánh dấu hoặc mục tiêu đã chết, một phần sát thương mà mục tiêu đã chịu sẽ chuyển thành trị liệu cho bản thân. Ba đòn đánh kế tiếp sẽ chuyển thành lao tới kẻ địch (cự ly vừa). Nếu như đó là tướng thì giảm thêm 0.5 giây hồi chiêu của Quét kiếm."
        }
    },
    {
        id: 23,
        name: "Zuka",
        poster: "https://i.pinimg.com/originals/75/9e/31/759e31ba72a45c13ebcb0bc97eabe4ee.jpg",
        skill1: {
            name: "Võ hồn",
            img: `${ZukSk1}`,
            delta: "Nội tại: Mỗi 15 giây khi gây sát thương lên tướng địch giúp kích hoạt nội lực. Zuka, tăng thêm công vật lý trong 1 thời gian."
        },
        skill2: {
            name: "Loạn đả bổng",
            img: `${ZukSk2}`,
            delta: "Zuka lướt tới trước vung gậy phỉ thúy tấn công kẻ địch, gây sát thương vật lý lên những nạn nhân lân cận. Chiêu thức này có thể tái sử dụng trong vòng 5 giây kế, đồng thời mỗi lần tung chiêu cường hóa đòn đánh thường kế tiếp của Zuka giúp gây thêm sát thương vật lý và gia tăng tầm đánh."
        },
        skill3: {
            name: "Phi thân kích",
            img: `${ZukSk3}`,
            delta: "Zuka lộn nhào về phía trước, gây sát thương vật lý lên những nạn nhân trúng chiêu dọc đường bay. Tung chiêu trúng đích giúp Zuka nhận lá chắn trong 2.5 giây, đồng thời cường hóa đòn đánh thường kế tiếp gây thêm sát thương vật lý (tăng theo cấp tướng) và hất tung các kẻ địch lân cận trong 0.5 giây. Khi khiên vỡ, Zuka được hồi máu mỗi giây trong 3 giây."
        },
        skill4: {
            name: "Trầm trọng lực",
            img: `${ZukSk4}`,
            delta: "Zuka phóng vút lên không rồi nện xuống mặt đất, gây sát thương vật lý lên các nạn nhân trong vùng ảnh hưởng, đồng thời làm choáng trúng trong 1 giây. Đòn đánh thường kế tiếp của Zuka được cường hóa, gây thêm sát thương vật lý lên những kẻ địch lân cận."
        }
    },
    {
        id: 24,
        name: "Gildur",
        poster: "https://i.pinimg.com/originals/ff/95/13/ff951382e212ddceb9df707966de6f11.jpg",
        skill1: {
            name: "Bàn tay vàng",
            img: `${GilSk1}`,
            delta: "Nội tại: Đòn đánh thường thứ tư liên tiếp đẩy lùi mục tiêu phía trước và gây sát thương phép. Đồng thời, Guldur sẽ nhận được lá chắn."
        },
        skill2: {
            name: "Quả đấm vàng",
            img: `${GilSk2}`,
            delta: "Gildur xông tới với cú đấm hoàng kim gây sát thương vật lý lên tất cả kẻ địch trúng chiêu. Đòn đánh kế tiếp của Gildur sẽ kích hoạt nội tại Bàn tay vàng."
        },
        skill3: {
            name: "Vụ nổ vàng",
            img: `${GilSk3}`,
            delta: "Gildur ném vàng làm choáng và gây sát thương phép lên tất cả kẻ địch trong tầm chiêu."
        },
        skill4: {
            name: "Vương quốc vàng",
            img: `${GilSk4}`,
            delta: "Gildur liên tục công kích làm choáng và gây sát thương phép lên tất cả kẻ địch trúng chiêu. Chiêu thức này cần đứng yên niệm chú. Sau 1 giây nếu dùng chiêu thức khác hoặc di chuyển sẽ gây hủy chiêu."
        },
    },
    {
        id: 25,
        name: "Airi",
        poster: "https://i.pinimg.com/originals/57/82/b1/5782b121c61a502b9f1612691c17c262.jpg",
        skill1: {
            name: "Sắc lẻm",
            img: `${AirSk1}`,
            delta: "Nội tại: Mỗi đòn đánh thường giúp giảm thời gian hồi của Kiếm khí đi 1 giây."
        },
        skill2: {
            name: "Phi tiêu",
            img: `${AirSk2}`,
            delta: "Airi ném phi tiêu về phía trước gây sát thương vật lý đồng thời làm choáng các nạn nhân trúng đòn trong thoáng chốc."
        },
        skill3: {
            name: "Kiếm vũ",
            img: `${AirSk3}`,
            delta: "Airi múa kiếm lướt theo hướng chỉ định gây sát thương vật lý. Chiêu thức này có thể tung tối đa 3 lượt trước khi tiến vào thời gian hồi chiêu."
        },
        skill4: {
            name: "Long kiếm",
            img: `${AirSk4}`,
            delta: "Airi tung Long kiếm, gây át thương vật lý lên các mục tiêu và làm chậm chúng. Ngay sau đó Airi tiếp tục tung kiếm, gây lượng sát thương vật lý tương tự và làm choáng các nạn nhân trong 1 giây. Mỗi tướng địch trúng chiêu giúp Airi nhận lá chắn giúp chặn sát thương. Chưa hết, Airi còn được tăng tốc chạy giảm dần trong 2.5 giây kèm 30% tốc đánh trong 8 giây."
        }
    },
    {
        id: 26,
        name: "Allain",
        poster: "https://i.pinimg.com/originals/a4/7a/ff/a47aff90ff190fc23e342bac0dd8df1a.jpg",
        skill1: {
            name: "Kiếm gầm",
            img: `${AllSk1}`,
            delta: "Đòn đánh thường của Allain gồm 4 thức gây tổng 7 lần sát thương và không bị ảnh hưởng bởi tốc đánh. Khi tấn công địch sẽ cộng dồn thành dấu ấn song kiếm: 6 lần đánh đầu tiên bao gồm cả 40% công vật lý sát thương vật lý và sát thương phép. Thức đánh cuối sẽ gây 60% công vật lý sát thương chuẩn. Ngoài ra, cứ 1% tốc đánh sẽ chuyển thành 2 công vật lý Tung đòn đánh thường, trúng tướng địch sẽ cộng dồn giúp tăng 2% miễn thương, 5% xuyên giáp trong 1 giây. Đạt đủ 8 lần sẽ giúp bản thân hồi 8% máu đã mất, đủ 16 lần sẽ hồi máu gấp đôi đồng thời bỏ cộng dồn trong thoáng chốc."
        },
        skill2: {
            name: "Kiếm lưu ngân",
            img: `${AllSk2}`,
            delta: "Allain tung gồm có 4 thức gây tổng 9 lần sát thương. Đệ nhất thức sẽ hất tung tướng địch ở gần. 7 đòn chém đầu sẽ gây hỗn hợp 40% công vật lý sát thương vật lý và sát thương phép. Hai đòn chém cuối sẽ gây 60% và 80% công vật lý sát thương chuẩn. Chiêu này có thể chí mạng và kích hoạt hiệu ứng đánh thường. Kích hoạt theo số lần dấu ấn song kiếm. Thức đầu tiên cộng dồn đủ 3 lần sẽ giúp bản thân được miễn khống chế. Đòn kiếm khí cuối cùng có thể chuyển hướng."
        },
        skill3: {
            name: "Kiếm tỏa mệnh",
            img: `${AllSk3}`,
            delta: "Allain vung kiếm lướt theo hướng chỉ định và gây 200/240/280/320/360/400 + (0.5 công vật lý) sát thương vật lý lên những kẻ địch trên đường lướt. Kẻ địch đầu tiên sẽ bị trói chân trong 1/1.2/1.4/1.6/1.8/2 giây. Tối đa có thể dự trữ 2 lần, mỗi 10 giây tích lũy 1 lần, chịu ảnh hưởng hồi chiêu từ trang bị."
        },
        skill4: {
            name: "Kiếm tất sát",
            img: `${AllSk4}`,
            delta: "Allain lập tức biến mất và khóa 1 tướng địch. Sau 1.5 giây hắn phóng xuống vị trí kẻ địch và gây 300/450/600 (+12/15/18% + 1% mỗi 50 công vật lý máu hiện tại của mục tiêu) sát thương chuẩn (mỗi khi trúng thêm 1 tướng sát thương tăng thêm 25%, tối đa tăng 50%). Hiệu ứng chiêu thức sẽ căn cứ vào kẻ bị khóa là tướng địch hay tướng đồng minh. Khóa tướng địch: Khiến địch bị làm chậm 50% và sát thương chiêu này chuyển thành lá chắn cho bản thân trong 3 giây. Khóa đồng đội: Bản thân được tăng tốc 50%. Sát thương gây ra cho địch có 50% chuyển thành lá chắn cho đồng đội trong 3 giây. Nếu khóa Butterfly, cô sẽ miễn khống chế trong thời gian này ."
        }
    },
    {
        id: 27,
        name: "Capheny",
        poster: "https://i.pinimg.com/originals/21/78/76/217876280bb9226ab5d0a62f6e26f056.jpg",
        skill1: {
            name: "Pháo tự động",
            img: `${CapSk1}`,
            delta: "Nội tại: Khẩu pháo tự động siêu tối tân 'Đệ tứ' cho phép Capheny có thể vừa di chuyển vừa tấn công, chưa hết nó còn sở hữu 2 cơ chế bắn: 'Đại liên' và 'Đại bác', bù lại Capheny gây giảm 50% sát thương lên quái rừng (tăng dần trở lại bình thường theo cấp tướng). Ngoài ra tất cả tốc đánh nhận từ trang bị sẽ được chuyển hóa sang công vật lý."
        },
        skill2: {
            name: "Đại bác đại liên",
            img: `${CapSk2}`,
            delta: "Đại bác: Capheny tăng tầm đánh, tiêu hao 20 năng lượng mỗi lần tấn công (tự động chuyển về Đại liên khi hết năng lượng) và bắn xuyên mục tiêu, gây sát thương vật lý. Mỗi kẻ địch trúng đạn sẽ khiến sát thương giảm đi 10% xuống tối thiểu 50%. Ngoài ra do súng nặng, và sức giật cao nên Capheny bị giảm tốc chạy. Đại liên: Capheny được hồi năng lượng, càng nhiều nếu tấn công lên kẻ địch. Cô nàng sẽ bắn hai viên liên tục, gây sát thương vật lý."
        },
        skill3: {
            name: "Pha phản lực pha động lực",
            img: `${CapSk3}`,
            delta: "Pha phản lực: Capheny lướt về phía trước và làm mới hoạt ảnh tấn công. Đồng thời, mỗi đòn đánh của cô sẽ tạo bùa chí mạng tăng 1% tỷ lệ chí mạng, cộng dồn 10 lần. Xuất hiện ở trạng thái Đại bác. Pha động lực: Capheny xoá hiệu ứng làm chậm đang chịu, tăng tốc chạy, đồng thời nhận bùa xuyên giáp, cộng dồn 10 lần. Xuất hiện ở trạng thái Đại liên, Bùa xuyên giáp và bùa chí mạng sẽ chuyển hoá toàn bộ thành bùa tương ứng khi Capheny đổi dạng súng"
        },
        skill4: {
            name: "Mưa liên thanh",
            img: `${CapSk4}`,
            delta: "Capheny xả 15 đợt mưa đạn liên tục theo hình nón phía trước gây sát thương vật lý mỗi 0.2 giây. Kẻ địch trúng chiêu sẽ bị giảm giáp; hiệu ứng có cộng dồn. Suốt thời gian này Capheny vẫn có thể di chuyển, bù lại bị giảm tốc chạy."
        }
    },
    {
        id: 28,
        name: "Florentino",
        poster: "https://i.pinimg.com/originals/ee/f3/df/eef3dfd07b6e41dab5a205b7807de6fd.jpg",
        skill1: {
            name: "Xuất chúng",
            img: `${FloSk1}`,
            delta: "Đột kích: Florentino khi rời giao tranh sẽ khiến đòn đánh thường kế tiếp lướt tới kẻ địch, gây sát thương vật lý, đồng thời làm chậm tốc chạy kẻ địch. Đòn đánh thường tiếp theo đó sẽ được tăng sát thương. Đột kích trúng tướng địch giúp Florentino hồi máu. Kiếm bộ: Sau khi tung Đột kích, Florentino sẽ lướt một đoạn ngắn, miễn nhiễm mọi hiệu ứng khống chế. Lướt xong Florentino được tăng tốc chạy."
        },
        skill2: {
            name: "Hào hoa",
            img: `${FloSk2}`,
            delta: "Florentino phóng hoa vào kẻ địch, gây sát thương vật lý, làm choáng địch. Dùng trúng địch sẽ tạo ra ba đoá hoa trong 5 giây. Nhặt hoa sẽ giúp Florentino hồi 100 nội năng, đồng thời khiến đòn đánh kế tiếp Đột kích và hoàn lại hồi chiêu của Thưởng hoa."
        },
        skill3: {
            name: "Thưởng hoa",
            img: `${FloSk3}`,
            delta: "Florentino tung ba nhát kiếm xảo diệu lên kẻ địch, mỗi lần gây thêm sát thương chuẩn bằng 1 phần máu tối đa kẻ địch. Khi kết thúc chiêu có thể tung Kiếm bộ, nếu trúng tướng địch sẽ giảm 1 giây hồi chiêu. Hào hoa Thưởng hoa: Gây sát thương vật lý. Hộ hoa: Gây sát thương vật lý và hất tung. Khai hoa: tung kiếm hai lần gây sát thương vật lý mỗi kiếm"
        },
        skill4: {
            name: "Tài hoa",
            img: `${FloSk4}`,
            delta: "Florentino lướt đến phía trước, Quyết đấu với tướng đầu tiên trúng chiêu. Trong 5 giây kế tiếp, Florentino gây thêm sát thương lên mục tiêu, đồng thời giảm giáp kẻ đó. Suốt thời gian này, Florentino miễn nhiễm mọi khống chế và miễn sát thương từ những kẻ địch không bị Quyết đấu. Nếu hạ gục mục tiêu, Florentino nhận công vật lý vĩnh viễn, cộng dồn 10 lần."
        }
    },
    {
        id: 29,
        name: "Lauriel",
        poster: "https://i.pinimg.com/originals/66/09/45/660945414a6eb4852d54544c147737c8.jpg",
        skill1: {
            name: "Trời phạt",
            img: `${LauSk1}`,
            delta: "Nội tại: Các chiêu thức trúng đích của Lauriel sẽ khắc dấu ấn Trời phạt lên mục tiêu. Khi đạt đủ 4 lần tích lũy, dấu ấn sẽ bùng nổ giúp Lauriel hồi máu, gây sát thương chuẩn diện rộng kèm hiệu ứng làm chậm tốc chạy giảm dần lên mục tiêu."
        },
        skill2: {
            name: "Con đường sám hối",
            img: `${LauSk2}`,
            delta: "Lauriel vẽ ra một con đường ánh sáng gây sát thương phép. Trong thoáng chốc sau đó, con đường sẽ bùng nổ gây lượng sát thương tương tự lần nữa lên những nạn nhân còn trong vùng hiệu lực."
        },
        skill3: {
            name: "Đôi cánh thuần khiết",
            img: `${LauSk3}`,
            delta: "Lauriel tung cánh lướt đến hướng chỉ định. Khi đến nơi, nàng vỗ cánh tạo ra 3 luồng ánh sáng tấn công kẻ địch gây sát thương phép theo mỗi luồng. Kẻ địch trúng chiêu giúp giảm thời gian hồi chiêu."
        },
        skill4: {
            name: "Đại phán xét",
            img: `${LauSk4}`,
            delta: "Lauriel triệu hồi sức mạnh thần thánh tạo ra một pháp trận hùng mạnh trong 1 thời gian, gây sát thương phép lúc xuất hiện và biến mất. Trong vùng hiệu lực Lauriel hồi chiêu nhanh gấp đôi bình thường."
        }
    },
    {
        id: 30,
        name: "Laville",
        poster: "https://i.pinimg.com/originals/43/73/55/437355211675526afdb208e5d287ee7c.jpg",
        skill1: {
            name: "Đạn liên châu",
            img: `${LavSk1}`,
            delta: "Mỗi đòn đánh thường trúng đích của Laville lên mục tiêu sẽ giúp bản thân tích lũy nội tại, tối đa tích lũy 3 tầng. Mỗi tầng nội tại giúp Laville tăng 10% tốc đánh. Khi đạt đủ 3 tầng đòn đánh thường của hắn sẽ chuyển thành Đạn liên châu khiến mỗi đòn đánh bắn ra 3 phát đạn, mỗi phát đạn gây sát thương bằng 40% của đòn đánh thường. Trạng thái này kéo dài trong 3 giây và được làm mới mỗi khi bắn trúng mục tiêu"
        },
        skill2: {
            name: "Đạn truy ảnh",
            img: `${LavSk2}`,
            delta: "Laville cường hóa bản thân khiến mỗi đòn đánh gây sát thương vật lý. Nếu bản thân đang trong trạng thái Đạn liên châu, mỗi phát đạn sẽ gây sát thương bằng 40% của đòn đánh thường đồng thời gây 50% sát thương lên 2 kẻ địch khác trong phạm vi. Hiệu ứng kéo dài trong 5 giây"
        },
        skill3: {
            name: "Khiên phản tốc",
            img: `${LavSk3}`,
            delta: "Laville nhận 1 lá chắn đỡ chiêu và tăng 60% tốc chạy cho bản thân trong 1.5 giây đồng thời đòn đánh thường trong 3 giây kế sẽ khiến mục tiêu bị làm chậm 15% trong 1.5 giây, tối đa cộng dồn 3 lần. Lá chắn đỡ chiêu tướng địch thành công sẽ giúp bản thân Laville được bất tử thoáng chốc và khiến 1 đòn đánh thường của Laville trong 3 giây kế tiếp sẽ gây sát thương chí mạng"
        },
        skill4: {
            name: "Đạn thần quang",
            img: `${LavSk4}`,
            delta: "Laville kết hợp đôi súng thần quang bắn ra phát đạn ánh sáng có thể bay xuyên bản đồ gây sát thương vật lý bùng nổ trong phạm vi lên tướng địch và khiến chúng bị choáng. Tướng địch trực tiếp trúng chiêu này sẽ bị choáng từ 0.5 - 3.5 giây (đạn bay càng xa mục tiêu choáng càng lâu)"
        }
    },
    {
        id: 31,
        name: "Maloch",
        poster: "https://i.pinimg.com/originals/40/c2/45/40c2459ef78d0c171fbbe7d13188b93f.jpg",
        skill1: {
            name: "Ma vương",
            img: `${MalSk1}`,
            delta: "Nội tại: Maloch sở hữu tầm đánh gấp đôi tướng cận chiến khác. Ngoài ra, sau khi tung chiêu Quỷ Kiếm trúng tướng địch, Maloch sẽ tiến vào trạng thái Ma Vương khiến sát thương kĩ năng và đòn đánh gây ra thành sát thương chuẩn 100% (bao gồm cả chí mạng), đồng thời hồi máu dựa theo máu tổn thất và công vật lý trên mỗi đòn đánh thường."
        },
        skill2: {
            name: "Quỷ kiếm",
            img: `${MalSk2}`,
            delta: "Maloch vận sức trong thoáng chốc rồi vung kiếm gây sát thương vật lý. Đặc biệt, nếu nạn nhân là tướng địch, kỹ năng này sẽ khiến Maloch tiến vào trạng thái Ma Vương trong 1 thời gian. Hắn được hồi máu dựa theo máu tổn thất trên mỗi tướng địch trúng chiêu (tối đa 4 tướng)."
        },
        skill3: {
            name: "Đoạt hồn",
            img: `${MalSk3}`,
            delta: "Maloch tước đoạt linh hồn của tướng địch lân cận và gây một lượng sát thương vật lý nhỏ cùng hiệu ứng làm chậm trong thời gian tiếp theo. Ngoài ra, lớp lá chắn còn được cường hóa theo số linh hồn hắn tước đoạt (tối đa 3 nạn nhân), giúp chặn sát thương."
        },
        skill4: {
            name: "Luyện ngục",
            img: `${MalSk4}`,
            delta: "Maloch chỉ định một khu vực rồi phóng vút lên không và lao xuống vùng ảnh hưởng, gây sát thương vật lý đồng thời hất văng các mục tiêu bên trong. Những nạn nhân cố tiến vào hoặc thoát ra khu vực này đều sẽ bị làm chậm. Nếu trúng tướng địch thì Maloch sẽ nhận hiệu ứng Ma vương trong thời gian tiếp theo."
        }
    },
    {
        id: 32,
        name: "Natalya",
        poster: "https://i.pinimg.com/originals/f4/b8/59/f4b859239c992093b2a1da8192cc70c6.jpg",
        skill1: {
            name: "Âm hỏa",
            img: `${NatSk1}`,
            delta: "Nội tại: dùng kỹ năng sẽ gây thêm sát thương phép cho địch, có thể cộng dồn tối đa 10 lần trong 3 giây."
        },
        skill2: {
            name: "Ác quỷ tụ hội",
            img: `${NatSk2}`,
            delta: "Natalya triệu hồi 5 bóng ma tấn công nơi chỉ định, gây sát thương phép. Mục tiêu trúng nhiều bóng ma sẽ phải chịu thêm sát thương với các bóng ma sau. Các bóng ma trúng tướng địch sẽ biến mất ngay sau đó, giúp Natalya giảm hồi chiêu và hồi lại 1 phần năng lượng."
        },
        skill3: {
            name: "Quả cầu hắc ám",
            img: `${NatSk3}`,
            delta: "Natalya tung ra một quả cầu năng lượng gây choáng nếu bay hết tầm hoặc trúng kẻ địch đầu tiên, rồi tiếp tục lơ lửng thêm thoáng chốc khiến các nạn nhân trong tầm ảnh hưởng chịu sát thương phép liên tục 5 lần và bị làm chậm tốc chạy."
        },
        skill4: {
            name: "Tia sáng tử vong",
            img: `${NatSk4}`,
            delta: "Natalya tập trung năng lượng phóng ra một luồng năng lượng chết chóc gây sát thương phép mỗi 0.25 giây, đồng thời nhận được một lớp lá chắn giúp miễn dịch trạng thái khống chế và chặn sát thương thời gian hiệu lực. Natalya sẽ xóa toàn bộ hiệu ứng khống chế trên bản thân, đồng thời miễn nhiễm với chúng chừng nào chiếc khiên còn tồn tại."
        }
    },
    {
        id: 33,
        name: "Paine",
        poster: "https://i.pinimg.com/originals/6b/27/cc/6b27ccb39815691454c974643cfa9424.jpg",
        skill1: {
            name: "Trảm hồn",
            img: `${PaiSk1}`,
            delta: "Sau mỗi lần tung chiêu, trong 4 giây kế các đòn đánh thường của Paine sẽ gây 225 + 12/cấp tướng + 0.375 công phép sát thương phép. Trong đó đòn đánh thường đầu tiên sẽ chuyển thành đột kích sau lưng kẻ địch và gây gấp đôi sát thương. Mỗi lần hạ hoặc phụ sẽ giúp Paine tăng 10 nôị năng, tối đa tăng giới hạn đến mức 200 nội năng."
        },
        skill2: {
            name: "Hồn gọi xác",
            img: `${PaiSk2}`,
            delta: "Paine xuất hồn theo hướng chỉ định và gây 150/180/210/240/270/300 (+0.6 công phép) sát thương phép cho kẻ địch trên đường xuyên qua đồng thời được miễn khống chế. Khi chiêu kết thúc hoặc ấn kết thúc, thể xác Paine sẽ lao nhanh đến vị trí linh hồn của hắn và gây tiếp sát thương phép lên kẻ địch trên đường lao đồng thời làm chậm kẻ địch 50% trong 1 giây."
        },
        skill3: {
            name: "Vong hồn trận",
            img: `${PaiSk3}`,
            delta: "Paine tung ra một vòng sáng ma hồn gây 300/350/400/450/500/550 (+0.35 công phép) sát thương phép lên kẻ địch trong phạm vi và khiến chúng câm lặng 0.75 giây. Nếu 2 giây sau khi tung chiêu Paine vẫn còn trong vòng sáng ma hồn thì hắn sẽ được hồi 40/50/60/70/80/90 nội năng. Nội tại chiêu: Khi Paine chịu sát thương phép, trong 5 giây sẽ chuyển hóa 30% lượng sát thương này thành máu cho bản thân"
        },
        skill4: {
            name: "Diệt hồn truy",
            img: `${PaiSk4}`,
            delta: "Sau khi tụ lực, Paine trong thời gian ngắn nhận 50% miễn thương và lao đến điểm chỉ định đồng thời gây 600/800/1000 (+1.0 công phép) sát thương phép. Ngoài ra những kẻ địch đứng trên đường lao sẽ phải chịu 50% sát thương phép."
        }
    },
    {
        id: 34,
        name: "Tel'Annas",
        poster: "https://i.pinimg.com/originals/82/f7/c5/82f7c5d40e04b4431b893e73cf10ead1.png",
        skill1: {
            name: "Sao trời",
            img: `${TelSk1}`,
            delta: "Nội tại: Tăng 8% công vật lý khi có tướng đồng minh xung quanh."
        },
        skill2: {
            name: "Ưng nhãn",
            img: `${TelSk2}`,
            delta: "Tăng mạnh tầm đánh và tốc đánh. Các đòn đánh thường được cường hóa bởi sức mạnh bóng tối, gây thêm sát thương vật lý"
        },
        skill3: {
            name: "Ám tiễn",
            img: `${TelSk3}`,
            delta: "Tel’Annas bắn một lúc 3 mũi tên gây sát thương vật lý lên tất cả kẻ địch trúng chiêu, làm giảm tốc chạy của chúng. Mỗi khi mũi tên trúng tướng địch, Tel'Annas được tăng tốc chạy trong 1 thời gian."
        },
        skill4: {
            name: "Hỗn mang tiễn",
            img: `${TelSk4}`,
            delta: "Sau thoáng chốc niệm chú, Tel’Annas bắn ra một mũi tên hỗn mang, gây sát thương vật lý và làm choáng tướng địch."
        }
    },
    {
        id: 35,
        name: "Violet",
        poster: "https://i.pinimg.com/originals/66/1c/54/661c54d782c28e3bd686b0ce36d13870.png",
        skill1: {
            name: "Nạp đạn",
            img: `${VioSk1}`,
            delta: "Nội tại: Đánh thường và chiêu 2, chiêu 3 trúng tướng địch giảm 0,5 s hồi chiêu của Đạn Xuyên Thấu"
        },
        skill2: {
            name: "Đạn xuyên thấu",
            img: `${VioSk2}`,
            delta: "Violet lộn về phía trước, cường hóa hóa đòn đánh thường tiếp theo, gây sát thương vật lý lên những kẻ địch đứng theo đường thẳng, đồng thời giúp gia tăng tầm đánh trong thoáng chốc. Lộn về phía kẻ địch sẽ được tăng 50% tốc chạy trong 2 giây."
        },
        skill3: {
            name: "Lựu đạn nổ",
            img: `${VioSk3}`,
            delta: "Violet ném lựu đạn vào những kẻ thù trong phạm vi, gây sát thương vật lý và làm chậm tốc chạy của chúng trong 1 giây."
        },
        skill4: {
            name: "Pháo đại",
            img: `${VioSk4}`,
            delta: "Violet tấn công những kẻ thù trong phạm vi với phát pháo cực đại, gây sát thương kèm theo 12% máu đã mất của kẻ địch sát thương vật lý."
        }
    },
    {
        id: 36,
        name: "Volkath",
        poster: "https://i.pinimg.com/originals/7a/27/ee/7a27ee9d2d0f9cc4ec731983d97af918.jpg",
        skill1: {
            name: "Ma quân",
            img: `${VolSk1}`,
            delta: "Volkath gây sát thương lên mục tiêu sẽ cộng dồn ấn ký ma quân, tích lũy đủ 4 tầng sẽ nổ tung gây 200+ (110% công vật lý cộng thêm ) sát thương vật lý đồng thời giúp Volkath nhận được lá chắn trị giá 200+(100% công vật lý ) trong 3 giây (+100 điểm sát thương & lá chắn mỗi 4 cấp tướng); lá chắn hồi chiêu trong 8 giây."
        },
        skill2: {
            name: "Bá vương trảm",
            img: `${VolSk2}`,
            delta: "Volkath vung đao chém ngang gây 350/400/450/500/550/600 ( +1.3 công vật lý) sát thương vật lý lên địch trong phạm vi xung quanh, nếu đánh trúng mục tiêu dính ấn ký ma quân, hắn sẽ gây thêm 40% sát thương và làm choáng 1 giây."
        },
        skill3: {
            name: "Bá vương trảo",
            img: `${VolSk3}`,
            delta: "Volkath tung Bá vương trảo gây 260/280/300/320/340/360 ( + 0.6 sát thương vật lý ) sát thương vật lý lên tướng địch khiến mục tiêu bị làm chậm thoáng chốc và đánh dấu trong 5 giây, suốt thời gian này nạn nhân sẽ bị lộ diện. Trong lúc còn bị đánh dấu, Volkath có thể tái kích hoạt chiêu để biến đến cạnh mục tiêu và gây 400/450/500/550/600/650 ( +1.1 công vật lý ) cộng thêm 16% máu nạn nhân đã mất thành sát thương vật lý. Nạn nhân chịu đánh dấu bị hạ bởi chiêu này sẽ khiến Volkath lập tức hoàn tất thời gian hồi chiêu Bá vương trảo 2"
        },
        skill4: {
            name: "Bất tử ma thân",
            img: `${VolSk4}`,
            delta: "Volkath triệu hồi sức mạnh hỗn mang giúp thoát khỏi các trạng thái khống chế đang gánh chịu và nhận 5%/10%/15% miễn thương, đồng thời trở thành kỵ sĩ trong 8 giây khiến các đòn đánh thường gây 20 ( +1 công vật lý ) sát thương vật lý trong phạm vi hình tròn. Suốt thời gian này Volkath có thể tái kích hoạt chiêu để đẩy lui địch xung quanh và gây 300/450/600 ( +1.6 công vật lý ) sát thương vật lý đồng thời biến thành Chúa tể hắc ám trong 3.5 giây. Sau khi biến thân Volkath được tăng 80% tốc đánh, 30% tốc chạy và được bất tử. Khi bất tử kết thúc Volkath sẽ được hồi 25% máu. Ma uy: trong trạng thái kỵ sĩ, mỗi đòn đánh thường trúng tướng địch sẽ cộng dồn 1 tầng ma uy, tối đa 3 tầng. Mỗi tầng ma uy sẽ giúp Volkath kéo dài thời gian bất tử thêm 0.5 giây."
        }
    },
    {
        id: 37,
        name: "Alice",
        poster: "https://i.pinimg.com/originals/c1/d2/78/c1d278b429620481995f3599e769af2f.jpg",
        skill1: {
            name: "Bước chân thần tốc",
            img: `${AliSk1}`,
            delta: "Nội tại: Sử dụng một kỹ năng sẽ tăng tốc chạy trong 1 giây."
        },
        skill2: {
            name: "Vụ nổ thời không",
            img: `${AliSk2}`,
            delta: "Alice gọi đến áng sáng mặt trời, gây sát thương phép và làm choáng những kẻ thù trúng chiêu."
        },
        skill3: {
            name: "Lá chắn thời không",
            img: `${AliSk3}`,
            delta: "Alice tạo ra một lá chắn cho đồng minh và làm tăng tốc chạy của họ."
        },
        skill4: {
            name: "Dòng chảy thời không",
            img: `${AliSk4}`,
            delta: "Alice tạo ra một vùng năng lượng ma thuật, mỗi 0.5 giây gây sát thương phép, đồng thời làm giảm giáp phép và tốc chạy của các nạn nhân trong vùng ảnh hưởng. Ngoài ra những kẻ dại dột bước vào vùng năng lượng này sẽ phải chịu hiệu ứng câm lặng trong 1 giây."
        }
    },
    {
        id: 38,
        name: "Aleister",
        poster: "https://i.pinimg.com/originals/b4/72/eb/b472ebd6c857e5230dd107e320508b7c.jpg",
        skill1: {
            name: "Ma thuật đen",
            img: `${AleSk1}`,
            delta: "Nội tại: Aleister nguyền rủa một mục tiêu với mỗi kỹ năng thứ 3. Mỗi lần cộng dồn thứ 3 sẽ kích hoạt một vụ nổ gây sát thương chuẩn."
        },
        skill2: {
            name: "Vách ngăn hắc ám",
            img: `${AleSk2}`,
            delta: "Aleister triệu hồi vách ngăn hắc ám, làm choáng và gây sát thương phép lên kẻ địch. Thời điểm ma trận gây sát thương và khi ma trận biến mất sẽ đặt một dấu ấn ma thuật đen lên kẻ địch."
        },
        skill3: {
            name: "Ma trận thống khổ",
            img: `${AleSk3}`,
            delta: "Aleister triệu hồi một ma trận liên tục gây sát thương lên kẻ thù, mỗi lượt gây sát thương phép. Mỗi lần gây sát thương tạo một điểm ma thuật đen."
        },
        skill4: {
            name: "Ngục tù vĩnh hằng",
            img: `${AleSk4}`,
            delta: "Aleister bẫy kẻ địch trong nhà tù ma thuật, gây sát thương phép mỗi lượt trong 2.5 giây. Chiêu thức cần niệm chú để thực hiện, tối đa dài 3 giây, tuy nhiên sau 0.7 giây đầu nếu thực hiện các thao tác khác có thể hủy."
        }
    },
    {
        id: 39,
        name: "Ata",
        poster: "https://i.pinimg.com/originals/9e/58/d9/9e58d95be89df3adbdc01acc33706d9a.jpg",
        skill1: {
            name: "Biển sâu chúc phúc",
            img: `${AtaSk1}`,
            delta: "Ata khi mất máu sẽ kích hoạt thanh máu ảo. Trong thời gian máu ảo còn tồn tại, hắn sẽ hồi lại phần máu ảo đó dựa trên sát thương gây ra ( 50% lên tướng) / 25% lên quái và lính). Sau 7 giây, thanh máu ảo sẽ tụt 3% mỗi giây. Đồng thời đòn đánh thường của Ata gây thêm 40 (+ 0.5% máu tối đa) sát thương vật lý"
        },
        skill2: {
            name: "Đạp sóng",
            img: `${AtaSk2}`,
            delta: "Ata tung người lên rồi rơi xuống vị trí chỉ định lần 1 gây 150/165/180/195/210/225 (+ 6% máu tối đa) sát thương vật lý. Kế đó hắn nhảy thêm một lần nữa gây sát thương tương tự và làm choáng địch 0.5 giây. Trong thời gian này Ata sẽ miễn khống chế."
        },
        skill3: {
            name: "Bá vương trảo",
            img: `${AtaSk3}`,
            delta: "Ata vung mỏ neo xương cá vào kẻ địch phía trước gây 150/180/210/240/270/300 (+50% công vật lý) sát thương vật lý và làm chậm địch 60% trong 1.5 giây, đồng thời kéo chúng một đoạn ngắn. Nếu mỏ neo đâm trúng địa hình, Ata sẽ lướt tới địa hình và lôi theo toàn bộ những kẻ trên đường lướt, gây choáng 1 giây, khiến chúng chịu thêm 150/165/180/195/210/225 (+ 5% máu tối đa) sát thương vật lý"
        },
        skill4: {
            name: "Thuyền bạch tuột",
            img: `${AtaSk4}`,
            delta: "Ata triệu hồi ra con thuyền khổng lồ trong 4 giây khiến các tướng hai phe không thể vượt qua và lập tức gây 250/325/400 (+ 90% công vật lý) sát thương vật lý lên những kẻ địch trước mặt. Khi tung chiêu Ata sẽ miễn khống chế, và kích hoạt lần nữa sẽ huỷ chiêu."
        }
    },
    {
        id: 40,
        name: "Toro",
        poster: "https://i.pinimg.com/originals/d0/57/3e/d0573ec6f831cadf6edce076012650f9.jpg",
        skill1: {
            name: "Mình đồng da sắc",
            img: `${TorSk1}`,
            delta: "Nội tại: Khi tung chiêu, Toro không thể bị khống chế và được giảm sát thương nhận vào."
        },
        skill2: {
            name: "Sừng trâu",
            img: `${TorSk2}`,
            delta: "Toro nhào tới những kẻ thù của mình, gây sát thương vật lý đồng thời hất tung những nạn nhân trúng chiêu."
        },
        skill3: {
            name: "Dư chấn",
            img: `${TorSk3}`,
            delta: "Toro ngửa mặt lên trời rống giận, tự tạo cho bản thân mình một lớp khiên chắn sát thương, gây sát thương vật lý cho những kẻ thù trong tầm kỹ năng và làm chậm tốc chạy của chúng."
        },
        skill4: {
            name: "Đại địa chấn",
            img: `${TorSk4}`,
            delta: "Toro dậm 3 lần lên mặt đất. Hai đợt đầu gây sát thương vật lý và làm chậm tốc chạy của kẻ địch. Đợt 3 gây sát thương vật lý và hất tung mục tiêu."
        }
    },
    {
        id: 41,
        name: "Grakk",
        poster: "https://i.pinimg.com/originals/65/48/bb/6548bb422fcbdcb7b660f8559353fdab.jpg",
        skill1: {
            name: "Huyết tế",
            img: `${GraSk1}`,
            delta: "Nội tại: Khi chịu sát thương vượt quá 10% lượng máu hiện tại sẽ bùng nổ (2 giây hồi chiêu ), gây sát thương phép trong phạm vi 500m xung quanh. Sau 3 giây khi Grakk tử vong, tại vị trí bị tiêu diệt sẽ bùng nổ gây sát thương phép trong phạm vi 5m xung quanh."
        },
        skill2: {
            name: "Càn quét",
            img: `${GraSk2}`,
            delta: "Grakk như hóa thành động không đáy, hút tất cả kẻ địch lân cận vào cạnh bên, gây sát thương phép và làm chậm 30% tốc chạy của những kẻ địch trúng chiêu. Các nạn nhân lân cận Grakk sẽ chịu gấp đôi sát thương và hiệu ứng làm chậm, cũng như câm lặng 0.5 giây"
        },
        skill3: {
            name: "Xích ma quái",
            img: `${GraSk3}`,
            delta: "Grakk tung dây khóa kéo địch đến trước mặt, và gây sát thương phép. Nội tại: Mỗi lần Grakk tiêu diệt hoặc hỗ trợ sẽ tăng máu bản thân thêm 125, tối đa cộng dồn 20 lần."
        },
        skill4: {
            name: "Nuốt chửng",
            img: `${GraSk4}`,
            delta: "Sau thoáng chốc, Grakk liên tục làm choáng và hút kẻ địch trước mặt, sát thương phép trong 3 giây. Đồng thời, Grakk sẽ tự tạo một lá chắn giá trị tương đương lên bản thân nếu chiêu trúng địch."
        }
    },
    {
        id: 42,
        name: "Zip",
        poster: "https://i.pinimg.com/originals/1b/62/37/1b62372b1cd1de4a70af9b7634c2c439.jpg",
        skill1: {
            name: "Béo đô đô",
            img: `${ZipSk1}`,
            delta: "Zip biến lớn và được tăng 30% miễn thương đồng thời mỗi giây gây 120 sát thương phép lên địch trong phạm vi, mỗi lần thăng cấp tăng 10 sát thương (sát thương gây ra với lính và quái rừng tăng gấp đôi)."
        },
        skill2: {
            name: "Ác hận",
            img: `${ZipSk2}`,
            delta: "Zip niệm ma chú, gây sát thương phép lên mục tiêu và làm choáng 0.75 giây. Sau đó ma chú tiếp tục tìm và khóa các tướng địch lân cận. Nếu không có đối tượng gần đấy, mục tiêu chính sẽ bị giảm 90% tốc chạy trong 1.5 giây. Nếu thành công khóa được mục tiêu khác ma chú sẽ gây sát thương phép mỗi 0.5 giây với mục tiêu đầu tiên, tối đa kéo dài 4 giây. Trong thời gian này nếu mục tiêu nào bị trúng đòn cũng sẽ truyền cho người còn lại 60% sát thương phép Khi cự ly giữa hai mục tiêu quá xa sẽ khiến ma chú bị đứt và khiến cả 2 bị choáng 0.75 giây. Trong thời gian ma chú tồn tại, mỗi đòn đánh thường của Zip gây thêm sát thương phép"
        },
        skill3: {
            name: "Khí thôn",
            img: `${ZipSk3}`,
            delta: "Zip há to mồm mở ra không gian thứ nguyên. Sau 1 giây hút đồng đội và quái rừng lân cận vào bụng trong 4 giây. Đồng đội trong phạm vi ảnh hưởng được nhận lá chắn, miễn thương 30% còn Zip mỗi lần hút được 1 mục tiêu sẽ được hồi máu. Lúc này tất cả sát thương Zip gánh chịu sẽ truyền 50% vào lá chắn của đồng đội. Trong quá trình hút, Zip được miễn khống chế và liên tục gây sát thương lên lính địch. Nếu ngừng hút nửa chừng sẽ được giảm phần lớn thời gian hồi chiêu này."
        },
        skill4: {
            name: "Lăn long lóc",
            img: `${ZipSk4}`,
            delta: "Zip biến thành trái cầu thịt, tăng tốc di chuyển lên tối đa và được miễn khống chế đồng thời lăn theo hướng chỉ định trong 6 giây. Trong khi lăn Zip gây sát thương phép lên kẻ địch trên đường lăn và hất tung 1 giây. Khi kết thúc giảm tốc chạy của địch xung quanh 50% trong 3 giây. Nếu lăn trúng vách cản sẽ lăn ngược lại và tăng thêm tốc lăn. Kích hoạt thêm một lần sẽ khiến dừng lăn, thời gian hồi chiêu được tính theo thời gian đã lăn."
        }
    },
    {
        id: 43,
        name: "Aya",
        poster: "https://i.pinimg.com/originals/11/6f/cb/116fcb84243ccd1a1879aa7f7936e934.jpg",
        skill1: {
            name: "Linh hồn sóc nhỏ",
            img: `${AyaSk1}`,
            delta: "Dưới 40% máu, Aya biến thành sóc nhỏ trong 5 giây, không bị chọn làm mục tiêu và nhận bộ chiêu thức mới."
        },
        skill2: {
            name: "Nốt nhạc ánh sáng",
            img: `${AyaSk2}`,
            delta: "Bắn ra quang cầu gây sát thương phép và làm chậm kẻ địch đồng thời khiến địch lộ diện"
        },
        skill3: {
            name: "Rừng sâu bảo hộ",
            img: `${AyaSk3}`,
            delta: "Aya bay đến biến thành lớp giáp ảo bảo vệ đồng đội chỉ định. Nếu đã trong trạng thái giáp ảo, Aya lập tức tạo thêm lá chắn cho đồng đội. Kéo chiêu để nhảy ra khỏi đồng đội."
        },
        skill4: {
            name: "Khúc nhạc rừng sâu",
            img: `${AyaSk4}`,
            delta: "Tạo pháp trận quanh đồng đội có lá chắn linh hồn giúp đồng đội tăng tốc chạy và gây sát thương lên địch trong phạm vi khiến địch bị biến hình"
        }
    },
    {
        id: 44,
        name: "Ilumia",
        poster: "https://i.pinimg.com/originals/9b/0b/6b/9b0b6bd8913abbf879ef889d9f838ceb.jpg",
        skill1: {
            name: "Thần lực",
            img: `${IluSk1}`,
            delta: "Nội tại: Quả cầu ánh sáng sẽ lập tức được làm mới thời gian hồi, đồng thời được cường hóa trong vòng 3 giây tiếp theo sau mỗi khi Ilumia tung 2 chiêu bất kỳ."
        },
        skill2: {
            name: "Quả cầu ánh sáng",
            img: `${IluSk2}`,
            delta: "Ilumia tung quả cầu năng lượng theo hướng chỉ định, phát nổ khi bay hết tầm hoặc trúng phải mục tiêu, gây sát thương phép. Khi được cường hóa bởi nội tại, Quả cầu ánh sáng sẽ gây thêm nhiều sát thương trên đường bay, tăng tối đa nếu ở điểm cuối và hất văng các nạn nhân trúng chiêu. Những nạn nhân bị hất văng khi chạm đất sẽ bị choáng và làm chậm."
        },
        skill3: {
            name: "Trục xuất",
            img: `${IluSk3}`,
            delta: "Ilumia đẩy lùi mọi kẻ địch lân cận, gây sát thương phép. Nếu có nạn nhân trúng chiêu, chúng sẽ bị làm chậm và khiến Ilumia được tăng tốc chạy."
        },
        skill4: {
            name: "Thần trận",
            img: `${IluSk4}`,
            delta: "Ilumia triệu hồi pháp trận chứa đầy sức mạnh thần thánh ngay vị trí hiện tại của tất cả tướng địch, làm hiện hình chúng trong thời gian ngắn, gây sát thương phép và làm choáng các nạn nhân."
        }
    },
    {
        id: 45,
        name: "Aoi",
        poster: "https://i.pinimg.com/originals/04/1c/bf/041cbf9003c1626fead3da2039e6cbef.jpg",
        skill1: {
            name: "Long lực",
            img: `${AoiSk1}`,
            delta: "Sau mỗi lần tung chiêu, Aoi sẽ tích lũy 1 lần Long lực (tối đa 4 lần) đồng thời cường hóa đòn đánh thường kế thành đột kích khiến đòn này được tăng tầm đánh và tốc đánh - gây sát thương vật lý lên mục tiêu. Đòn đánh thướng thứ 4 nhất định sẽ gây chí mạng và khiến bản thân giảm hồi chiêu."
        },
        skill2: {
            name: "Long trảm",
            img: `${AoiSk2}`,
            delta: "Aoi tung trảo đột kích về phía trước và gây sát thương vật lý lên kẻ địch trong phạm vi. Đánh trúng địch giúp bản thân được hồi máu. Trạng thái phi hành: Aoi bổ nhào xuống vị trí chỉ định gây sát thương vật lý và hất tung tất cả các mục tiêu trong phạm vi. Đánh trúng kẻ địch giúp bản thân nhận lá chắn."
        },
        skill3: {
            name: "Long trảo",
            img: `${AoiSk3}`,
            delta: "Aoi phóng trảo vào chướng ngại vật, dùng nút di chuyển tiến vào trạng thái Xung kích hoặc Phi hành. Có thể dự bị 2 lần (chịu ảnh hưởng hồi chiêu); Khi xung kích và phi hành, bản thân Aoi được miễn khống."
        },
        skill4: {
            name: "Long diệt",
            img: `${AoiSk4}`,
            delta: "Aoi bay lên trời (không bị chọn làm mục tiêu), cắm long trảo vào kẻ địch và gây sát thương vật lý dồng thời làm chậm. Sau đó trong thoáng chốc, Aoi lướt về phía sau đồng thời thu hồi song trảo và gây máu mục tiêu đã mất thành sát thương vật lý lên phạm vi lớn."
        }
    },
    {
        id: 46,
        name: "Sinestrea",
        poster: "https://i.pinimg.com/originals/e5/71/e1/e571e1168ccc096d4c50c0e23bb388e6.jpg",
        skill1: {
            name: "Hoa máu",
            img: `${SinSk1}`,
            delta: "Ô kỹ năng chủ động của trang bị sẽ luôn được thay bằng chiêu Huyết tế. Huyết tế: Vận chiêu trong vòng 3 giây, Sinestrea tử vong và gây sát thương vật lý đồng thời làm choáng tất cả địch trong phạm vi. Quá trình này không thể ngăn cản hoặc hủy chiêu. Mỗi khi bản thân hạ 1 tướng địch, Sinestrea sẽ nhận được một đóa Hoa máu. Mỗi đóa sau khi Huyết tế bùng nổ sẽ giúp Sinestrea giảm thời gian hồi sinh. Nếu Sinestrea có đủ 7 đóa hoa, sau khi bùng nổ Huyết tế, nàng sẽ được hồi sinh ngay tại chỗ và lập tức hoàn tất hồi tất cả các chiêu của bản thân."
        },
        skill2: {
            name: "Ngủ đông",
            img: `${SinSk2}`,
            delta: "Sinestrea lướt đến vị trí chỉ định. Sau khi hạ xuống nâng lập tức tiến vào trạng thái ngủ đông. Sinestrea chỉ cần duy trì không di chuyển một thời gian thì bản thân nàng sẽ được tàng hình. Dưới trạng thái cận chiến, Sinestrea sẽ chuyển thành đột kích."
        },
        skill3: {
            name: "Máu quỷ",
            img: `${SinSk3}`,
            delta: "Đổi trạng thái cận chiến & đánh xa. Đánh thường cận chiến: Gây thêm máu đã mất của mục tiêu thành sát thương vật lý và hút máu. Đánh thường xa: Mỗi đòn đánh thường sẽ tiêu hao máu hiện tại của bản thân và gây sát thương vật lý đồng thời khiến mục tiêu bị găm Huyết ấn. Giải trừ trạng thái đánh xa: Khiến tất cả Huyết ấn găm trên thân kẻ địch bị triệu hồi thành Huyết kiếm và liên tục bắn đến vị trí chỉ định, gây sát thương vật lý. Nếu gọi kiếm về bản thân. mỗi thanh Huyết kiếm sẽ giúp bản thân hồi phục máu đã mất."
        },
        skill4: {
            name: "Thay máu",
            img: `${SinSk4}`,
            delta: "Sinestrea dùng máu của bản thân làm Nghi thức cầu nối khống chế cắm vào kẻ địch. Sau khi nghi thức kết thúc, Sinestrea sẽ hồi máu."
        }
    },
    {
        id: 47,
        name: "Lindis",
        poster: "https://i.pinimg.com/originals/ee/7d/30/ee7d306bbef64091f66e7da41559c2a9.jpg",
        skill1: {
            name: "Phục kích",
            img: `${LinSk1}`,
            delta: "Nội tại: Di chuyển giữa các bụi cỏ giúp Lindis tăng tốc chạy thoáng chốc, đồng thời khiến đòn đánh thường kế tiếp bắn hai lần, mỗi lần gây thêm sát thương vật lý."
        },
        skill2: {
            name: "Nguyệt quang",
            img: `${LinSk2}`,
            delta: "Nội tại: Đòn đánh thứ 3 trúng cùng mục tiêu sẽ gây thêm sát thương vật lý. Lindis triệu hồi mặt trăng giúp soi sáng xung quanh và phát hiện kẻ địch trong 5 giây, tối đa dự trữ 2 điểm cộng dồn."
        },
        skill3: {
            name: "Nguyệt vực",
            img: `${LinSk3}`,
            delta: "Lindis tạo ra một cái bẫy tồn tại tối đa 2 phút tại điểm đã chọn. Khi tiếp xúc với kẻ địch chiếc bẫy sẽ làm mục tiêu lộ diện đồng thời bộc phát tạo ra một vùng làm chậm tốc chạy và gây sát thương vật lý sau thoáng chốc. Lindis tối đa dự trữ được 2 bẫy. Những chiếc bẫy này nếu không bị kích hoạt bởi kẻ địch sẽ trở nên tàng hình sau 2 giây."
        },
        skill4: {
            name: "Nguyệt ảnh",
            img: `${LinSk4}`,
            delta: "Lindis triệu hồi ảo ảnh tấn công kẻ địch, gây sát thương vật lý kèm các hiệu ứng trên đòn đánh. Lindis có thể dự trữ tối đa 5 ảo ảnh, và thời gian hồi giữa hai lần dùng ảo ảnh liên tiếp là 2 giây."
        }
    },
    {
        id: 48,
        name: "Errol",
        poster: "https://i.pinimg.com/originals/85/db/f4/85dbf4847de295957c7f951afa8ec9e8.jpg",
        skill1: {
            name: "Tay ác ma",
            img: `${ErrSk1}`,
            delta: "Đòn đánh thường trúng đích giúp Errol tăng 1 điểm Quỷ trảo, nhiều nhất 5 điểm, giúp tăng tốc chạy, tốc đánh, hút máu, nhưng giảm kháng phép và vật lý. Quỷ trảo kéo dài 5 giây. Mỗi 3 lần công thường tay phải sẽ chuyển thành tay ác ma đột kích."
        },
        skill2: {
            name: "Tay lưỡi liềm",
            img: `${ErrSk2}`,
            delta: "Errol lướt phía trước vung tay lưỡi liềm quét ngang kẻ địch, gây sát thương vật lý  Trong quá trình lướt trúng gặp địch sẽ khiến địch bị định thân, đồng thời Errol thuấn di cạnh kẻ địch và tung Tay lưỡi liềm chém ngang địch, giảm hồi chiêu và hồi 1 phần máu đã mất."
        },
        skill3: {
            name: "Tay đại đao",
            img: `${ErrSk3}`,
            delta: "Tay phải hóa thành đại đao, chém xuống những kẻ địch trên đường thẳng gây sát thương vật lý và làm chậm, kéo dài 1 giây. Trúng tướng địch hồi cho bản thân 1 phần máu đã mất. Nếu đang đầy điểm Quỷ trảo sẽ tiêu hao hết điểm để gây sát thương nhân đôi, hút máu gấp đôi và đánh bay kẻ địch."
        },
        skill4: {
            name: "Mắt ma",
            img: `${ErrSk4}`,
            delta: "Errol phóng lên không trung và trở nên bất tử trong 2 giây, suốt thời gian này hắn có thể tự do chọn điểm rơi. Khi kết thúc, Errol hóa thành vòng xoáy xuyên thủng mặt đất gây sát thương vật lý và hất tung địch."
        }
    },
    {
        id: 49,
        name: "Dirak",
        poster: "https://i.pinimg.com/736x/47/07/52/470752bdafeeadd4d59a504dd07d0a9c.jpg",
        skill1: {
            name: "Giáp năng lượng",
            img: `${DirSk1}`,
            delta: "Khi máu sắp cạn, Dirak sẽ tiêu hao năng lượng để chống đỡ sát thương, mỗi 1 năng lượng sẽ chống đỡ được 1 sát thương"
        },
        skill2: {
            name: "Kim quang ấn",
            img: `${DirSk2}`,
            delta: "Dirak triệu hồi ra Kim quang ấn đánh về phía trước, đẩy lùi tướng địch trong thoáng chốc."
        },
        skill3: {
            name: "Thiên hoả trận",
            img: `${DirSk3}`,
            delta: "Dirak dựng lên một pháp trận tại khu vực chỉ định. Trong thoáng chốc, thiên thạch sẽ rơi xuống đẩy lùi địch. Đồng thời, Dirak cũng có thể chọn hướng rơi cho thiên thạch."
        },
        skill4: {
            name: "Lô cốt tử quang",
            img: `${DirSk4}`,
            delta: "Dirak gọi ra một tấm chắn năng lượng chặn đứng mọi phát đạn của kẻ địch và sau đó giúp hắn thi triển Pháo tử quang. Pháo tử quang: Gây sát thương cực lớn cho kẻ địch trên phạm vi bắn thẳng."
        }
    },
    {
        id: 50,
        name: "Stuart",
        poster: "https://i.pinimg.com/736x/1f/97/f8/1f97f8d6a140ac8dcdb0d68183c74729.jpg",
        skill1: {
            name: "Thể năng cường hóa",
            img: `${StuSk1}`,
            delta: "Nội tại: Đánh thường và dùng chiêu 1, chiêu 3 sẽ nhận được năng lượng, tối đa 4 cộng dồn. Khi đạt tối đa, hắn được cường hóa."
        },
        skill2: {
            name: "Phi đạn tử vong",
            img: `${StuSk2}`,
            delta: "Bắn phi đạn trên đường thẳng và gây sát thương lên mọi mục tiêu trên đường bay"
        },
        skill3: {
            name: "Huyết ảnh ma nhãn",
            img: `${StuSk3}`,
            delta: "Miễn thương vật lý và tăng tốc chạy"
        },
        skill4: {
            name: "Hủy diệt bộc phá",
            img: `${StuSk4}`,
            delta: "Stuart lướt đến mục tiêu, làm chậm và gây sát thương hắn."
        }
    },
    {
        id: 51,
        name: "Bijan",
        poster: "https://i.pinimg.com/736x/c0/e8/8e/c0e88e635cd550819dc30b9cfb8d2d2e.jpg",
        skill1: {
            name: "Sa mạc thần lực",
            img: `${Bijan1}`,
            delta: "Sau mỗi đoạn thời gian, Bijan cường hóa đòn đánh thường kế gây sát thương vật lý và hồi máu cho bản thân. Khi nhận sát thương vật lý hoặc sát thương chuẩn hoặc tung chiêu trúng mục tiêu, Bijan sẽ được tăng thêm giáp."
        },
        skill2: {
            name: "Sa mạc mãnh kích",
            img: `${Bijan2}`,
            delta: "Lướt về phía trước vung chùy bổ xuống mục tiêu, gây sát thương và tạo pháp trận hất tung mục tiêu."
        },
        skill3: {
            name: "Sa mạc thần âm",
            img: `${Bijan3}`,
            delta: "Lướt về phía trước gây sát thương và làm chậm mục tiêu, đồng thời được tung chiêu quét ngang 3 lần."
        },
        skill4: {
            name: "Sa mạc thần thú",
            img: `${Bijan4}`,
            delta: "Gọi ra thần địa sa thú để điều khiển theo hướng chỉ định, nhận miễn khống. Khi trúng địa hình, tướng địch hoặc tài kích hoạt chiêu này, Bijan sẽ dừng lại, gây sát thương vật lý, hất tung địch đồng thời giảm giáp của chúng. Bijan có thể chở 1 đồng đội khi dùng chiêu này."
        }
    },
    {
        id: 52,
        name: "Điêu Thuyền",
        poster: "https://i.pinimg.com/736x/7e/35/af/7e35afe479e4b2444ecd3417c49a2eb5.jpg",
        skill1: {
            name: "Nữ hoàng băng tuyết",
            img: `${DieSk1}`,
            delta: "Nội tại: Nếu trong 1 thời gian không bị công kích hay khống chế, Điêu Thuyền sẽ nhận được một lớp lá chắn giúp chặn hoàn toàn một kỹ năng, bao gồm cả sát thương và hiệu ứng khống chế."
        },
        skill2: {
            name: "Sương giá",
            img: `${DieSk2}`,
            delta: "Điêu Thuyền tung phép thuật băng giá lên một vùng chỉ định, gây sát thương phép, và làm chậm 50% tốc chạy của các kẻ địch trúng chiêu."
        },
        skill3: {
            name: "Tuyết liên",
            img: `${DieSk3}`,
            delta: "Điêu Thuyền tạo bông sen băng gây sát thương phép, và đóng băng các kẻ địch trúng chiêu trong 2.5 giây. Điêu Thuyền có thể tích trữ tối đa 2 đóa Tuyết liên. Nếu mục tiêu trúng chiêu liên tục 2 lần trong 5 giây sẽ phải chịu đóng băng ít hơn ở lần thứ 2. Đặc biệt, những nạn nhân bị đóng băng sẽ phải chịu thêm sát thương phép từ mọi nguồn sát thương của Điêu Thuyền."
        },
        skill4: {
            name: "Bão tuyết",
            img: `${DieSk4}`,
            delta: "Điêu Thuyền gọi ra một trận bão tuyết tấn công những kẻ thù trong phạm vi, gây sát thương phép và làm chậm tốc chạy của nạn nhân. Đồng thời, cô được tăng thêm giáp. Chiêu thức này cần niệm chiêu để thực hiện, tối đa kéo dài 5.3 giây, tuy nhiên sau 0.6 giây đầu nếu di chuyển hoặc ấn chiêu lần nữa thì có thể hủy."
        }
    },
    {
        id: 53,
        name: "Arum",
        poster: "https://i.pinimg.com/736x/35/05/ba/3505ba2be3e60f92dd81e0e8394a65ce.jpg",
        skill1: {
            name: "Linh thú",
            img: `${Arum1}`,
            delta: "Nội tại: Arum triệu hồi linh thú vờn quanh bản thân, gây sát thương phép lên những kẻ địch lân cận, đồng thời giúp Arum hồi máu. Nếu nạn nhân trúng đòn không phải tướng địch, Arum sẽ chỉ được hồi ít máu hơn."
        },
        skill2: {
            name: "Thú kích",
            img: `${Arum2}`,
            delta: "Arum phóng năng lượng lan tỏa ra xung quanh gây sát thương phép lên những kẻ địch lân cận, đồng thời triệu hồi 1 linh thú vờn quanh bản thân. Tung chiêu trúng kẻ địch giúp giảm thời gian hồi 50%. Số lượng linh thú quyết định hiệu lực của Thú sổng; tối đa tồn tại 3 linh thú."
        },
        skill3: {
            name: "Thú sổng",
            img: `${Arum3}`,
            delta: "Arum lệnh cho linh thú tấn công vùng chỉ định gây sát thương phép, đồng thời giúp bản thân tăng tốc chạy trong thoáng chốc. Sau khi tấn công linh thú sẽ biến mất khỏi Arum. Số lượng linh thú quyết định số lần và hiệu quả công kích: linh thú đầu tiên làm chậm tốc chạy trong 1 giây, linh thú thứ hai làm chậm mạnh tốc chạy trong 1 giây, linh thú thứ ba gây choáng 1 giây."
        },
        skill4: {
            name: "Thú khốn",
            img: `${Arum4}`,
            delta: "Arum lướt đến trói buộc mục tiêu trong thời gian ngắn, đồng thời lập tức triệu hồi 3 linh thú vờn quanh bản thân. Suốt thời gian này cả Arum lẫn nạn nhân đều bất động hoàn toàn dưới tác động của mối liên kết không thể bị phá vỡ, đặc biệt mọi sát thương bất kỳ ai trong cả hai gánh chịu đều sẽ được truyền đến người còn lại."
        }
    },
    {
        id: 54,
        name: "Qi",
        poster: "https://i.pinimg.com/originals/13/d1/52/13d15283dd2708c40279858c521cef3b.jpg",
        skill1: {
            name: "Chân khí hộ thể",
            img: `${QiSk1}`,
            delta: "Qi giải phóng chân khí hộ thể, tối đa cộng dồn 3 lần, mỗi lần tăng 50 giáp. Nếu chiêu thức đánh trúng kẻ địch, 2 lần đánh thường kế tiếp sẽ được tăng 100% tốc đánh và gây thêm 40% sát thương vật lý, đồng thời hồi phục 60 máu."
        },
        skill2: {
            name: "Truy tinh chưởng",
            img: `${QiSk2}`,
            delta: "Qi lướt theo hướng chỉ định, gây 200/240/280/320/360/400 (+0.7 công vật lý) sát thương vật lý lên những kẻ địch đứng trên đường lướt đồng thời hất tung địch 0.5 giây"
        },
        skill3: {
            name: "Chấn thiên chưởng",
            img: `${QiSk3}`,
            delta: "Qi dùng chân khí đánh liên tiếp vào kẻ địch phía trước, mỗi đòn đánh gây 75/90/105/120/135/150 (+0.33 công vật lý) sát thương vật lý và giảm 15/22/29/36/43/50 giáp của địch. Chiêu này được cộng dồn tối đa 5 lần trong 5 giây."
        },
        skill4: {
            name: "Hạo nhiên chưởng",
            img: `${QiSk4}`,
            delta: "Qi xuất chưởng về phía trước gây 240/360/480 (+0.6 công vật lý) sát thương vật lý và đánh lui địch. Kẻ địch bị đánh lui va vào địa hình sẽ phải chịu thêm 80/120/160 (+0.2 công vật lý) sát thương vật lý và choáng 1.5 giây. Sau đó Qi có thể lướt tiếp theo hướng chỉ định, gây 160/240/320 (+0.4 công vật lý) (+15% máu mục tiêu đã mất) sát thương vật lý lên những kẻ địch trên đường lướt"
        }
    }
]
